webpackJsonp([1],Array(35).concat([
/* 35 */
/***/ (function(module, exports) {

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5fae97e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
  __webpack_require__(497)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-39c46a68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5508b236",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _access_to_services = __webpack_require__(538);

var _access_to_services2 = _interopRequireDefault(_access_to_services);

var _celebrate = __webpack_require__(539);

var _celebrate2 = _interopRequireDefault(_celebrate);

var _classroom_support = __webpack_require__(540);

var _classroom_support2 = _interopRequireDefault(_classroom_support);

var _collaborate = __webpack_require__(541);

var _collaborate2 = _interopRequireDefault(_collaborate);

var _combination = __webpack_require__(542);

var _combination2 = _interopRequireDefault(_combination);

var _comfort = __webpack_require__(543);

var _comfort2 = _interopRequireDefault(_comfort);

var _community = __webpack_require__(544);

var _community2 = _interopRequireDefault(_community);

var _conflict_resolution = __webpack_require__(545);

var _conflict_resolution2 = _interopRequireDefault(_conflict_resolution);

var _correct = __webpack_require__(546);

var _correct2 = _interopRequireDefault(_correct);

var _crosshair = __webpack_require__(194);

var _crosshair2 = _interopRequireDefault(_crosshair);

var _culture = __webpack_require__(547);

var _culture2 = _interopRequireDefault(_culture);

var _expression = __webpack_require__(549);

var _expression2 = _interopRequireDefault(_expression);

var _hatch_bg = __webpack_require__(195);

var _hatch_bg2 = _interopRequireDefault(_hatch_bg);

var _health = __webpack_require__(550);

var _health2 = _interopRequireDefault(_health);

var _home = __webpack_require__(551);

var _home2 = _interopRequireDefault(_home);

var _incorrect = __webpack_require__(552);

var _incorrect2 = _interopRequireDefault(_incorrect);

var _inspire = __webpack_require__(553);

var _inspire2 = _interopRequireDefault(_inspire);

var _learning_success = __webpack_require__(554);

var _learning_success2 = _interopRequireDefault(_learning_success);

var _listen = __webpack_require__(555);

var _listen2 = _interopRequireDefault(_listen);

var _mastery = __webpack_require__(556);

var _mastery2 = _interopRequireDefault(_mastery);

var _mentors = __webpack_require__(557);

var _mentors2 = _interopRequireDefault(_mentors);

var _neighborhood_cohesion = __webpack_require__(558);

var _neighborhood_cohesion2 = _interopRequireDefault(_neighborhood_cohesion);

var _networks = __webpack_require__(559);

var _networks2 = _interopRequireDefault(_networks);

var _next = __webpack_require__(560);

var _next2 = _interopRequireDefault(_next);

var _plus = __webpack_require__(561);

var _plus2 = _interopRequireDefault(_plus);

var _prev = __webpack_require__(562);

var _prev2 = _interopRequireDefault(_prev);

var _problem_solving = __webpack_require__(563);

var _problem_solving2 = _interopRequireDefault(_problem_solving);

var _protective = __webpack_require__(564);

var _protective2 = _interopRequireDefault(_protective);

var _relationships = __webpack_require__(565);

var _relationships2 = _interopRequireDefault(_relationships);

var _risk = __webpack_require__(566);

var _risk2 = _interopRequireDefault(_risk);

var _role_models = __webpack_require__(567);

var _role_models2 = _interopRequireDefault(_role_models);

var _school = __webpack_require__(568);

var _school2 = _interopRequireDefault(_school);

var _stability = __webpack_require__(569);

var _stability2 = _interopRequireDefault(_stability);

var _supportive_relationships = __webpack_require__(570);

var _supportive_relationships2 = _interopRequireDefault(_supportive_relationships);

var _temperment = __webpack_require__(571);

var _temperment2 = _interopRequireDefault(_temperment);

var _understanding = __webpack_require__(572);

var _understanding2 = _interopRequireDefault(_understanding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  'access-to-services': _access_to_services2.default,
  'celebrate': _celebrate2.default,
  'classroom-support': _classroom_support2.default,
  'collaborate': _collaborate2.default,
  'combination': _combination2.default,
  'comfort': _comfort2.default,
  'community': _community2.default,
  'conflict-resolution': _conflict_resolution2.default,
  'correct': _correct2.default,
  'svg-crosshair': _crosshair2.default,
  'culture': _culture2.default,
  'expression': _expression2.default,
  'hatch-bg': _hatch_bg2.default,
  'health': _health2.default,
  'home': _home2.default,
  'incorrect': _incorrect2.default,
  'inspire': _inspire2.default,
  'learning-success': _learning_success2.default,
  'listen': _listen2.default,
  'mastery': _mastery2.default,
  'mentors': _mentors2.default,
  'neighborhood-cohesion': _neighborhood_cohesion2.default,
  'networks': _networks2.default,
  'next': _next2.default,
  'plus': _plus2.default,
  'prev': _prev2.default,
  'problem-solving': _problem_solving2.default,
  'protective': _protective2.default,
  'relationships': _relationships2.default,
  'risk': _risk2.default,
  'role-models': _role_models2.default,
  'school': _school2.default,
  'stability': _stability2.default,
  'supportive-relationships': _supportive_relationships2.default,
  'temperment': _temperment2.default,
  'understanding': _understanding2.default
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var api_root = 'https://futures-without-violence-node.herokuapp.com';
var api_root_local = 'https://futures-without-violence-node.herokuapp.com';


var liveUrls = {
  server: {
    register: api_root + '/auth/register',
    login: api_root + '/auth/login',
    logout: api_root + '/auth/logout',
    authenticate: api_root + '/auth/authenticate',
    update: api_root + '/auth/update',
    preSurvey: api_root + '/survey/presurvey',
    postSurvey: api_root + '/survey/postsurvey'
  }
};

var devUrls = {
  server: {
    register: api_root_local + '/auth/register',
    login: api_root_local + '/auth/login',
    logout: api_root_local + '/auth/logout',
    authenticate: api_root_local + '/auth/authenticate',
    update: api_root_local + '/auth/update',
    preSurvey: api_root_local + '/survey/presurvey',
    postSurvey: api_root_local + '/survey/postsurvey'
  }
};

var apiUrls = {};

if (false) {
  console.log('api urls set to DEV');
  exports.apiUrls = apiUrls = devUrls;
} else {
  console.log('api urls set to PRODUCTION');
  exports.apiUrls = apiUrls = liveUrls;
}

exports.apiUrls = apiUrls;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var is_active = function is_active(context, conditional) {
  if (conditional) {
    context.$store.commit('set_navigation_next', {
      custom: 'button-disabled'
    });
  } else {
    context.$store.commit('set_navigation_next', {
      custom: ''
    });
  }
};

exports.is_active = is_active;

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(268);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (root, smoothScroll) {
    'use strict';

    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (smoothScroll),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : (0, _typeof3.default)(module)) === 'object') {
        module.exports = smoothScroll();
    } else {
        root.smoothScroll = smoothScroll();
    }
}(undefined, function () {
    'use strict';

    if ((typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) !== 'object') return;

    if (document.querySelectorAll === void 0 || window.pageYOffset === void 0 || history.pushState === void 0) {
        return;
    }

    var getTop = function getTop(element, start) {
        if (element.nodeName === 'HTML') return -start;
        return element.getBoundingClientRect().top + start;
    };

    var easeInOutCubic = function easeInOutCubic(t) {
        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };

    var position = function position(start, end, elapsed, duration) {
        if (elapsed > duration) return end;
        return start + (end - start) * easeInOutCubic(elapsed / duration);
    };

    var smoothScroll = function smoothScroll(el, duration, callback, context) {
        duration = duration || 500;
        context = context || window;
        var start = context.scrollTop || window.pageYOffset;

        if (typeof el === 'number') {
            var end = parseInt(el);
        } else {
            var end = getTop(el, start);
        }

        var clock = Date.now();
        var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
            window.setTimeout(fn, 15);
        };

        var step = function step() {
            var elapsed = Date.now() - clock;
            if (context !== window) {
                context.scrollTop = position(start, end, elapsed, duration);
            } else {
                window.scroll(0, position(start, end, elapsed, duration));
            }

            if (elapsed > duration) {
                if (typeof callback === 'function') {
                    callback(el);
                }
            } else {
                requestAnimationFrame(step);
            }
        };
        step();
    };

    var linkHandler = function linkHandler(ev) {
        ev.preventDefault();

        if (location.hash !== this.hash) window.history.pushState(null, null, this.hash);

        var node = document.getElementById(this.hash.substring(1));
        if (!node) return;

        smoothScroll(node, 500, function (el) {
            location.replace('#' + el.id);
        });
    };

    document.addEventListener("DOMContentLoaded", function () {
        var internal = document.querySelectorAll('a[href^="#"]:not([href="#"])'),
            a;
        for (var i = internal.length; a = internal[--i];) {
            a.addEventListener("click", linkHandler, false);
        }
    });

    return smoothScroll;
});

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(669),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3d22798",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(622),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ratio_styles = exports.ratio_height = undefined;

__webpack_require__(35);

var ratio_height = function ratio_height(context, el, ratio, options) {
  if (!el) return;
  var height = el.offsetWidth * ratio;

  var styles = {
    'height': height + 'px'
  };
  if (options) {
    if (options.override === true) {
      styles = {
        'height': 'auto'
      };
    }
  }

  context.ratio_styles = styles;
};

var ratio_styles = {};

exports.ratio_height = ratio_height;
exports.ratio_styles = ratio_styles;

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(626),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-559a30ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
  __webpack_require__(487)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1069aef2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c5934b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-327a557e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _full_page = __webpack_require__(578);

var _full_page2 = _interopRequireDefault(_full_page);

var _checkbox_page = __webpack_require__(576);

var _checkbox_page2 = _interopRequireDefault(_checkbox_page);

var _flip_card_page = __webpack_require__(577);

var _flip_card_page2 = _interopRequireDefault(_flip_card_page);

var _overflow_page = __webpack_require__(579);

var _overflow_page2 = _interopRequireDefault(_overflow_page);

var _share_page = __webpack_require__(583);

var _share_page2 = _interopRequireDefault(_share_page);

var _selector_page = __webpack_require__(582);

var _selector_page2 = _interopRequireDefault(_selector_page);

var _sponsor_page = __webpack_require__(584);

var _sponsor_page2 = _interopRequireDefault(_sponsor_page);

var _post_survey = __webpack_require__(580);

var _post_survey2 = _interopRequireDefault(_post_survey);

var _pre_survey = __webpack_require__(581);

var _pre_survey2 = _interopRequireDefault(_pre_survey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  'full-page': _full_page2.default,
  'checkbox-page': _checkbox_page2.default,
  'flip-card-page': _flip_card_page2.default,
  'overflow-page': _overflow_page2.default,
  'share-page': _share_page2.default,
  'selector-page': _selector_page2.default,
  'sponsor-page': _sponsor_page2.default,
  'post-survey': _post_survey2.default,
  'pre-survey': _pre_survey2.default
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (str) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str)) {
    return true;
  }
  return false;
};

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d5b80f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cd2d79b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(613),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bc49ab8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(511)
  __webpack_require__(510)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66536010",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
  __webpack_require__(489)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-158ed790",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(671),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ed0024fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
  __webpack_require__(484)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(591),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07f95614",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b7c5176",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0cfd18b0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(93);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(674);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _components = __webpack_require__(263);

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/auth_sandbox',
    component: _components2.default.auth_sandbox
  }, {
    path: '/sandbox',
    component: _components2.default.sandbox
  }, {
    path: '/audio',
    component: _components2.default.audio
  }, {
    path: '/style_guide',
    component: _components2.default.style_guide.main,
    children: [{
      path: 'fonts',
      component: _components2.default.style_guide.fonts
    }, {
      path: 'atoms',
      component: _components2.default.style_guide.atoms
    }, {
      path: 'molecules',
      component: _components2.default.style_guide.molecules
    }, {
      path: 'organisms',
      component: _components2.default.style_guide.organisms
    }, {
      path: '',
      component: _components2.default.style_guide.fonts
    }, {
      path: '*',
      component: _components2.default.style_guide.fonts
    }]
  }, {
    path: '*',
    component: _components2.default.main
  }]
});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(146);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(93);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(676);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    loggedIn: false,
    pages: [],
    page: 0,
    nextCondition: true,
    navActive: '',
    notification_state: {
      active: false,
      correctTitle: "You've got it!",
      incorrectTitle: 'Not quite.'
    },
    preSurvey: {
      changeTrigger: 0 },
    preSurveyData: [],
    postSurvey: {
      changeTrigger: 0 },
    postSurveyData: [],
    postSurveyError: false,
    checkbox: {
      el: null,
      correct: 'incorrect',
      caption: 'default caption'
    },
    navigation: {
      back: {
        text: 'back',
        custom: ''
      },
      next: {
        text: 'next',
        custom: ''
      }
    }
  },
  mutations: {
    change_page: function change_page(state, inc) {
      var new_page = state.page + inc;
      if (-1 < new_page && new_page < state.pages.length) {
        state.page = new_page;
      }
    },
    assign_page: function assign_page(state, ind) {
      state.page = ind;
    },
    set_navigation_next: function set_navigation_next(state, payload) {
      (0, _assign2.default)(state.navigation.next, payload);
    },
    set_navigation_back: function set_navigation_back(state, payload) {
      (0, _assign2.default)(state.navigation.back, payload);
    },
    set_notification: function set_notification(state, payload) {
      (0, _assign2.default)(state.notification_state, payload);
    },
    set_checkbox: function set_checkbox(state, payload) {
      (0, _assign2.default)(state.checkbox, payload);
    },
    set_pages: function set_pages(state, payload) {
      state.pages = payload;
    },
    setPreSurvey: function setPreSurvey(state, payload) {
      (0, _assign2.default)(state.preSurvey, payload);
      state.preSurvey.changeTrigger += 1;
    },
    setPostSurvey: function setPostSurvey(state, payload) {
      (0, _assign2.default)(state.postSurvey, payload);
      state.postSurvey.changeTrigger += 1;
    },
    setPreSurveyData: function setPreSurveyData(state, payload) {
      for (var i = 0; i < state.preSurveyData.length; i++) {
        if (state.preSurveyData[i].question === payload.question) {
          (0, _assign2.default)(state.preSurveyData[i], payload);
          return;
        }
      }
      state.preSurveyData.push(payload);
    },
    setPostSurveyData: function setPostSurveyData(state, payload) {
      for (var i = 0; i < state.postSurveyData.length; i++) {
        if (state.postSurveyData[i].question === payload.question) {
          (0, _assign2.default)(state.postSurveyData[i], payload);
          return;
        }
      }
      state.postSurveyData.push(payload);
    },
    setPostSurveyError: function setPostSurveyError(state, payload) {
      state.postSurveyError = payload;
    },
    setNextCondition: function setNextCondition(state, payload) {
      state.nextCondition = payload;
    },
    setLoggedIn: function setLoggedIn(state, payload) {
      state.loggedIn = payload;
    },
    setNavActive: function setNavActive(state, payload) {
      state.navActive = payload;
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(629),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type']
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_crosshair__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_crosshair___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_crosshair__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'crosshair-svg': __WEBPACK_IMPORTED_MODULE_0__svg_crosshair___default.a
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['image'],
  data: function data() {
    return {
      background_image: '',
      overlay_class: ''
    };
  },

  methods: {
    load_image: function load_image() {
      var context = this;
      var downloadingImage = new Image();
      downloadingImage.onload = function () {
        context.background_image = { "background-image": "url('" + context.image + "')" };
        setTimeout(function () {
          context.overlay_class = 'overlay-finished';
        });
      };
      downloadingImage.src = this.image;
    }
  },
  mounted: function mounted() {
    this.load_image();
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'correct', 'caption', 'title', 'group', 'groupQuestion'],
  data: function data() {
    return {
      el: ''
    };
  },

  methods: {
    uncheckAll: function uncheckAll() {

      var checkboxes = document.querySelectorAll('input.radio-button-checkbox');

      if (this.group) {
        checkboxes = document.querySelectorAll('input.radio-button-checkbox.' + this.group);
      }

      for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = false;
      }
    },
    groupStoreCallback: function groupStoreCallback(bool) {
      if (!this.group) return;

      this.$store.commit('setPreSurvey', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.group, bool));

      if (bool) {
        this.$store.commit('setPreSurveyData', {
          question: this.groupQuestion,
          response: this.title
        });
      }
    },
    check: function check() {
      var store = this.$store.state.checkbox.el;
      var el = this.$el;
      var snapshot = this.$refs.radioCheckbox.checked;

      this.uncheckAll();

      if (snapshot) {
        this.$refs.radioCheckbox.checked = true;
        this.groupStoreCallback(true);
      } else {
        this.$refs.radioCheckbox.checked = false;

        this.groupStoreCallback(false);
      }

      if (this.group) return;
      if (store === el) {
        this.$store.commit('set_checkbox', { el: null });
        this.$store.commit('set_navigation_next', {
          custom: 'button-disabled'
        });
      } else {
        this.$store.commit('set_checkbox', { el: el, correct: this.set_correct, caption: this.caption });
        this.$store.commit('set_navigation_next', {
          custom: ''
        });
      }
    }
  },
  computed: {
    button_disabled: function button_disabled() {
      var store = this.$store.state.checkbox.el;
      var el = this.el;
      if (store && el !== store) {
        return '';
      }
    },
    set_correct: function set_correct() {
      if (!this.correct) return 'incorrect';
      return 'correct';
    },
    is_correct: function is_correct() {
      if (!this.$store.state.checkbox.el || !this.$store.state.notification_state.active) return '';

      if (this.$store.state.checkbox.correct !== 'correct' && this.$store.state.checkbox.el !== this.$el) return '';

      if (!this.correct) return 'incorrect';
      return 'correct';
    }
  },
  mounted: function mounted() {
    this.el = this.$el;
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_hatch_bg__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_hatch_bg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_hatch_bg__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['full'],
  components: {
    'hatch-bg': __WEBPACK_IMPORTED_MODULE_0__svg_hatch_bg___default.a
  },
  computed: {
    customClasses: function customClasses() {
      if (!!this.full) {
        return 'hatch-full';
      }
    }
  }

});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['video', 'videoFile'],
  computed: {
    video_source: function video_source() {
      if (this.video.indexOf('embed') !== -1) return this.video;

      var embed_prefix = 'https://www.youtube.com/embed/';
      var url_string = this.video.split('/');
      var url_source = url_string[url_string.length - 1].replace('watch?v=', '');

      return embed_prefix + url_source;
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_arrow__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_arrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atoms_arrow__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'customclass', 'clickevent'],
  data: function data() {
    return {
      default_clickevent: function default_clickevent() {
        return false;
      }
    };
  },

  components: {
    'arrow': __WEBPACK_IMPORTED_MODULE_0__atoms_arrow___default.a
  },
  computed: {
    click_event: function click_event() {
      if (!this.clickevent) {
        return this.default_clickevent;
      }
      return this.clickevent;
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_crosshair_background__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_crosshair_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atoms_crosshair_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ratio_height__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ratio_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_ratio_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__ = __webpack_require__(49);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'icon', 'cardSize', 'ind', 'active'],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    'crosshair-background': __WEBPACK_IMPORTED_MODULE_1__atoms_crosshair_background___default.a
  }, __WEBPACK_IMPORTED_MODULE_2__svg___default.a),
  data: function data() {
    return {
      ratio_styles: __WEBPACK_IMPORTED_MODULE_3__utils_ratio_height__["ratio_styles"],
      flipped: null,
      contentActiveClass: 'content-inactive',
      psOne: null
    };
  },

  methods: {
    get_ratio: function get_ratio(w) {
      if (w.innerWidth < 1200) {
        return 2 / 3;
      }
      return 5 / 4;
    },
    flip: function flip() {
      var _this = this;

      if (!this.flipped) {
        this.flipped = 'flipped';
        this.$emit('flip', 1);
        setTimeout(function () {
          _this.psOne.update();
        }, 600);
      } else {
        this.flipped = null;
        this.$emit('flip', -1);
      }
    },
    ratioInit: function ratioInit() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_ratio_height__["ratio_height"])(this, this.$refs.flipCard, this.get_ratio(window));
      window.addEventListener('resize', function () {
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_ratio_height__["ratio_height"])(_this2, _this2.$refs.flipCard, _this2.get_ratio(window));
        }, 500);
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_ratio_height__["ratio_height"])(_this2, _this2.$refs.flipCard, _this2.get_ratio(window));
        }, 1000);
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_ratio_height__["ratio_height"])(_this2, _this2.$refs.flipCard, _this2.get_ratio(window));
        }, 1500);
      });
    },
    scrollBarInit: function scrollBarInit() {
      if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
        var containerOne = this.$refs.scrollHookOne;
        this.psOne = new __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__["a" /* default */](containerOne);
      } else if (this.psOne) {
        this.psOne.destroy();
        this.psOne = null;
      }
      window.addEventListener('resize', this.scrollBarInit);
    },
    activeCallback: function activeCallback() {
      var _this3 = this;

      var int = 800;
      var delay = 250 * this.ind;
      if (this.active) {
        setTimeout(function () {
          _this3.ratioInit();
          _this3.scrollBarInit();
          _this3.contentActiveClass = '';
        }, int + delay);
      } else {
        setTimeout(function () {
          _this3.contentActiveClass = 'content-inactive';
        }, int + delay);
      }
    }
  },
  computed: {
    cardSizeClass: function cardSizeClass() {
      if (this.cardSize < 3) {

        return this.ind < 1 ? 'span-4-lg offset-3-lg' : 'span-4-lg offset-2-lg';
      } else if (this.cardSize > 3) {
        return 'span-3-lg offset-1-lg';
      } else {
        return 'span-4-lg offset-1-lg';
      }
    }
  },
  mounted: function mounted() {
    this.activeCallback();
  },

  watch: {
    active: function active() {
      this.activeCallback();
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'title'],
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__svg___default.a),

  computed: {
    popup_border: function popup_border() {
      if (this.is_correct === 'correct') {
        return 'border-green';
      }
      return 'border-red';
    },
    is_correct: function is_correct() {
      return this.$store.state.checkbox.correct;
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_arrow__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_arrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atoms_arrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_emit_clicked__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_emit_clicked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_emit_clicked__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['transform', 'index', 'activeindex'],
  data: function data() {
    return {
      selectorClass: ''
    };
  },

  methods: {
    emit_clicked: __WEBPACK_IMPORTED_MODULE_1__utils_emit_clicked___default.a,
    selectorClicked: function selectorClicked() {
      this.selectorClass = 'checked';
      this.emit_clicked();
    }
  },
  components: {
    'arrow': __WEBPACK_IMPORTED_MODULE_0__atoms_arrow___default.a
  },
  computed: {
    active_class: function active_class() {
      if (this.index !== this.activeindex) {
        return {};
      }
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_radio__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atoms_radio__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'strong', 'correct', 'caption', 'full', 'survey', 'group', 'groupQuestion'],
  components: {
    'radio': __WEBPACK_IMPORTED_MODULE_0__atoms_radio___default.a
  },
  computed: {
    is_strong: function is_strong() {
      return this.strong;
    },
    is_full: function is_full() {
      if (!this.full) {
        return 'span-8-lg span-8-md span-16-sm span-16-xs';
      } else {
        return 'span-16-lg span-16-md span-16-sm span-16-xs';
      }
    },
    is_survey: function is_survey() {
      if (!this.survey) {
        return '';
      } else {
        return 'span-8-md span-16-sm span-16-xs';
      }
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['spanclass', 'ratioclass'],
  components: {
    'crosshair-background': __WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background___default.a
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['ind', 'caption']
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_span_background__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_span_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atoms_span_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__ = __webpack_require__(49);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['active', 'nobg'],
  components: {
    'span-background': __WEBPACK_IMPORTED_MODULE_1__atoms_span_background___default.a,
    'crosshair-background': __WEBPACK_IMPORTED_MODULE_0__atoms_crosshair_background___default.a,
    psOne: null
  },
  data: function data() {
    return {
      contentClass: 'content-inactive'
    };
  },

  methods: {
    scrollBarInit: function scrollBarInit() {
      if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
        var containerOne = this.$refs.scrollHookOne;
        this.psOne = new __WEBPACK_IMPORTED_MODULE_2_perfect_scrollbar__["a" /* default */](containerOne);
      } else if (this.psOne) {
        this.psOne.destroy();
        this.psOne = null;
      }
      window.addEventListener('resize', this.scrollBarInit);
    },
    activeCallback: function activeCallback() {
      var _this = this;

      var int = 800;
      if (this.active) {
        setTimeout(function () {
          _this.scrollBarInit();
          _this.contentClass = '';
        }, int);
        setTimeout(function () {
          if (_this.psOne) _this.psOne.update();
        }, int + 1000);
      } else {
        setTimeout(function () {
          _this.contentClass = 'content-inactive';
        }, int);
      }
    }
  },
  mounted: function mounted() {
    this.activeCallback();
  },

  watch: {
    active: function active() {
      this.activeCallback();
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      containerClass: '',
      subHeaderInactive: 'content-inactive',
      headerInactive: 'content-inactive'
    };
  },

  methods: {
    hideLanding: function hideLanding() {
      var _this = this;

      this.containerClass = 'invisible';
      setTimeout(function () {
        _this.containerClass = _this.containerClass + ' hide-all';
      }, 1000);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.subHeaderInactive = '';
    }, 1000);
    setTimeout(function () {
      _this2.headerInactive = '';
    }, 2000);
    setTimeout(function () {
      _this2.hideLanding();
    }, 4500);
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__molecules_button__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mainBackgroundClass: '',
      loadingOverlayClass: ''
    };
  },

  methods: {
    closeLanding: function closeLanding() {
      this.mainBackgroundClass = 'background-disabled';
      this.$emit('complete');
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.loadingOverlayClass = 'overlay-disabled';
    }, 250);
  },

  components: {
    'nav-button': __WEBPACK_IMPORTED_MODULE_0__molecules_button___default.a
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__molecules_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_addresses__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_api_addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_api_addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_valid_email__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_valid_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_valid_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      status: '',
      continuePage: false,
      modal: 'logIn',
      user: {
        email: '',
        password: ''
      },
      newUser: {
        firstName: '',
        lastName: '',
        email: '',
        password: ''
      },
      confirmPassword: '',
      containerClass: '',
      innerClass: '',
      showContinueControls: true
    };
  },

  computed: {
    continueCondition: function continueCondition() {
      if (this.continuePage || this.continuePage === 0) return true;
      return false;
    },
    logInModal: function logInModal() {
      return this.modal === 'logIn' && !this.continueCondition;
    },
    signUpModal: function signUpModal() {
      return this.modal === 'signUp' && !this.continueCondition;
    },
    statusClass: function statusClass() {
      return this.status ? '' : 'content-inactive';
    }
  },
  methods: {
    checkForEnter: function checkForEnter(e) {
      if (e.keyCode === 13) {
        this.logIn();
      }
    },
    toggleModal: function toggleModal() {
      var _this = this;

      this.innerClass = 'content-inactive';
      setTimeout(function () {
        _this.modal = _this.modal === 'logIn' ? 'signUp' : 'logIn';
        _this.status = '';
        _this.innerClass = '';
      }, 1000);
    },
    setUser: function setUser(data, prefix) {
      var _this2 = this;

      this.innerClass = 'content-inactive';
      setTimeout(function () {
        _this2.status = prefix + data.firstName;
        _this2.continuePage = data.page;
        _this2.innerClass = '';
      }, 1000);
    },
    logIn: function logIn() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__utils_api_addresses__["apiUrls"].server.login, this.user, { withCredentials: true }).then(function (response) {
        if (!response.data.authorized) {
          _this3.status = "Incorrect email address or password";
          _this3.continuePage = false;
        } else {
          _this3.setUser(response.data, "Welcome back, ");
          _this3.showContinueControls = false;
          setTimeout(function () {
            _this3.loginSuccess();
          }, 2000);
        }
      });
    },
    logOut: function logOut() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__utils_api_addresses__["apiUrls"].server.logout, { withCredentials: true }).then(function (response) {
        _this4.setUser({
          firstName: '',
          continuePage: false
        }, '');
      });
    },
    register: function register() {
      var _this5 = this;

      for (var key in this.newUser) {
        if (this.newUser[key] === '') {
          this.status = "Please complete all fields";
          return false;
        }
      }

      if (!/^[a-zA-Z]*$/.test(this.newUser.firstName) || !/^[a-zA-Z]*$/.test(this.newUser.lastName)) {
        this.status = "Names can only contain letters and spaces";
        return false;
      }

      if (!__WEBPACK_IMPORTED_MODULE_2__utils_valid_email___default()(this.newUser.email)) {
        this.status = "Please provide a valid email address";
        return false;
      }

      if (this.confirmPassword !== this.newUser.password) {
        this.status = "Passwords do not match";
        return false;
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__utils_api_addresses__["apiUrls"].server.register, this.newUser, { withCredentials: true }).then(function (response) {
        if (!response.data.authorized) {
          _this5.status = "A user with that email already exists!";
          _this5.continuePage = false;
        } else {
          _this5.setUser(response.data, "welcome, ");
          _this5.setSession();
          _this5.showContinueControls = false;
          setTimeout(function () {
            _this5.loginSuccess();
          }, 2000);
        }
      });
    },
    setSession: function setSession() {
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__utils_api_addresses__["apiUrls"].server.login, this.newUser, { withCredentials: true });
    },
    checkSession: function checkSession() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__utils_api_addresses__["apiUrls"].server.authenticate, { withCredentials: true }).then(function (response) {
        if (!response.data.authorized) {
          _this6.continuePage = false;
        } else {
          _this6.setUser(response.data, "Welcome back, ");
        }
      });
    },
    loginSuccess: function loginSuccess() {
      var _this7 = this;

      this.$store.commit('assign_page', 1);

      this.$store.commit('setLoggedIn', true);
      setTimeout(function () {
        _this7.$store.commit('assign_page', _this7.continuePage);
      });
      setTimeout(function () {
        _this7.containerClass = 'hide-login-container';
      }, 400);
      setTimeout(function () {
        var prev = _this7.containerClass;
        _this7.containerClass = prev + ' hide-all';
      }, 400 + 400);
    }
  },
  components: {
    'nav-button': __WEBPACK_IMPORTED_MODULE_0__molecules_button___default.a
  },
  mounted: function mounted() {
    this.checkSession();
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__molecules_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_vanilla_smooth_scroll__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_vanilla_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_vanilla_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_download__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_addresses__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api_addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_api_addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);









__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.withCredentials = true;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['nextCondition'],
  data: function data() {
    return {
      w: null,
      pdf: null
    };
  },

  methods: {
    setPDF: function setPDF() {
      this.pdf = this.$store.state.pages[this.page].content.pdf;
    },
    setNavActive: function setNavActive() {
      this.$store.commit('setNavActive', 'nav-active');
    },
    removeNavActive: function removeNavActive() {
      this.$store.commit('setNavActive', '');
    },
    changePage: function changePage(int) {
      var _this = this;

      var cb = function cb(i) {
        _this.$store.commit('change_page', i);

        if (i > 0) {
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__utils_api_addresses__["apiUrls"].server.update, {
            current_page: _this.$store.state.page
          }).catch(function (err) {
            console.log(err);
          });
        }
      };
      if (this.w.pageYOffset > 0) {
        __WEBPACK_IMPORTED_MODULE_1__utils_vanilla_smooth_scroll___default()(0, 250);
        setTimeout(function () {
          cb(int);
        }, 250);
      } else {
        cb(int);
      }
    },
    uncheckAllCheckboxes: function uncheckAllCheckboxes() {
      var checkboxes = document.querySelectorAll('[radio]');
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
    },
    next_click: function next_click() {

      if (!this.nextCondition) return;

      if (typeof this.nextCondition === 'function') {
        if (!this.nextCondition()) return;
        this.$store.commit('setNextCondition', true);
      }

      if (this.$store.state.checkbox.el && !this.$store.state.notification_state.active) {

        this.$store.commit('set_notification', { active: true });
      } else if (this.$store.state.checkbox.el && this.$store.state.notification_state.active) {

        var correct = this.$store.state.checkbox.correct;

        if (correct === 'correct') {
          this.$store.commit('set_checkbox', {
            el: null
          });
          this.changePage(1);
        }

        this.$store.commit('set_notification', { active: false });
      } else {
        this.changePage(1);
      }
    },
    back_click: function back_click() {
      this.$store.commit('setNextCondition', true);
      this.$store.commit('set_notification', { active: false });
      this.$store.commit('set_checkbox', {
        el: null
      });
      this.uncheckAllCheckboxes();
      this.changePage(-1);
    },
    set_first_last: function set_first_last() {
      var page = this.$store.state.page;
      var finish_page = this.$store.state.pages.length - 2;
      var last_page = this.$store.state.pages.length - 1;

      if (page < 2) {
        this.$store.commit('set_navigation_next', {
          text: page < 1 ? 'submit' : 'begin',
          custom: 'call-to-action'
        });

        this.$store.commit('set_navigation_back', {
          custom: page < 1 ? 'button-disabled-invisible' : ''
        });
      } else if (page === finish_page) {
          this.$store.commit('set_navigation_back', {
            custom: ''
          });
          this.$store.commit('set_navigation_next', {
            text: 'finish',
            custom: 'call-to-action'
          });
        } else if (page === last_page) {
          this.$store.commit('set_navigation_back', {
            custom: ''
          });
          this.$store.commit('set_navigation_next', {
            text: '',
            custom: 'button-disabled-invisible'
          });
        } else {
            this.$store.commit('set_navigation_back', {
              custom: ''
            });
            this.$store.commit('set_navigation_next', {
              text: 'next'
            });
          }
    }
  },
  computed: {
    page: function page() {
      return this.$store.state.page;
    },
    back: function back() {
      return this.$store.state.navigation.back;
    },
    next: function next() {
      return this.$store.state.navigation.next;
    },
    hasPDF: function hasPDF() {
      if (this.pdf) {
        return '';
      } else {
        return 'content-inactive';
      }
    },
    navActive: function navActive() {
      return this.$store.state.navActive;
    }
  },
  components: {
    'nav-button': __WEBPACK_IMPORTED_MODULE_0__molecules_button___default.a,
    'download-svg': __WEBPACK_IMPORTED_MODULE_2__svg_download___default.a
  },
  mounted: function mounted() {
    this.set_first_last();
    this.w = window;
  },

  watch: {
    page: function page() {
      this.setPDF();
      this.set_first_last();
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_popup_notification__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_popup_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__molecules_popup_notification__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['state', 'captionState'],
  components: {
    'popup-notification': __WEBPACK_IMPORTED_MODULE_0__molecules_popup_notification___default.a
  },
  methods: {
    make_inactive: function make_inactive() {
      var correct = this.$store.state.checkbox.correct;
      if (correct === 'correct') {
        this.$store.commit('change_page', 1);
      }
      this.$store.commit('set_notification', { active: false });
      this.$store.commit('set_checkbox', { el: null });
      var checkboxes = document.querySelectorAll('[radio]');
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
    }
  },
  computed: {
    notification_class: function notification_class() {
      var active = this.$store.state.notification_state.active;
      if (active) return '';
      return 'notification-inactive';
    },
    computedTitle: function computedTitle() {
      if (this.$store.state.checkbox.correct === 'correct') {
        return this.state.correctTitle;
      } else {
        return this.state.incorrectTitle;
      }
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_image_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atoms_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atoms_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_video_component__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atoms_video_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atoms_video_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atoms_span_background__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atoms_span_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__atoms_span_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atoms_crosshair_background__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atoms_crosshair_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atoms_crosshair_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__ = __webpack_require__(49);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['image', 'video', 'videoFile', 'align', 'active'],
  components: {
    'image-component': __WEBPACK_IMPORTED_MODULE_0__atoms_image_component___default.a,
    'video-component': __WEBPACK_IMPORTED_MODULE_1__atoms_video_component___default.a,
    'crosshair-background': __WEBPACK_IMPORTED_MODULE_3__atoms_crosshair_background___default.a,
    'span-background': __WEBPACK_IMPORTED_MODULE_2__atoms_span_background___default.a
  },
  data: function data() {
    return {
      ratio_styles: {
        height: 9 / 16 * 1200 * (2 / 3) + 'px'
      },
      contentActiveClass: 'content-inactive',
      mediaActiveClass: 'content-inactive',
      psOne: null
    };
  },

  methods: {
    scrollBarInit: function scrollBarInit() {
      if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
        var containerOne = this.$refs.scrollHookOne;
        this.psOne = new __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar__["a" /* default */](containerOne);
      } else if (this.psOne) {
        this.psOne.destroy();
        this.psOne = null;
      }
      window.addEventListener('resize', this.scrollBarInit);
    },
    activeCallback: function activeCallback() {
      var _this = this;

      var int = 800;
      if (this.active) {
        setTimeout(function () {
          _this.scrollBarInit();
          _this.contentActiveClass = '';
        }, int);
        setTimeout(function () {
          if (_this.psOne) _this.psOne.update();
        }, int + 1000);
        setTimeout(function () {
          _this.mediaActiveClass = '';
        }, int * 1.25);
      } else {
        setTimeout(function () {
          _this.contentActiveClass = 'content-inactive';
        }, int);
        setTimeout(function () {
          _this.mediaActiveClass = 'content-inactive';
        }, int * 1.25);
      }
    }
  },
  watch: {
    active: function active() {
      this.activeCallback();
    }
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    currentPage: function currentPage() {
      return this.$store.state.page;
    },
    allPages: function allPages() {
      return this.$store.state.pages.length - 1;
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['complete', 'hidden'],
  data: function data() {
    return {
      completeInt: 0,
      intervals: []
    };
  },

  computed: {
    barSize: function barSize() {
      return {
        'width': this.completeInt + '%'
      };
    },
    isHidden: function isHidden() {
      if (this.hidden) {
        return 'progress-hidden';
      } else {
        return '';
      }
    }
  },
  watch: {
    complete: function complete() {
      var _this = this;

      var curr = parseInt((this.complete * 100).toFixed());

      if (curr > 96) curr = 100;

      for (var i = 0; i < this.intervals.length; i++) {
        clearInterval(this.intervals[i]);
      }

      this.intervals.push(setInterval(function () {

        if (_this.completeInt === curr) {
          for (var _i = 0; _i < _this.intervals.length; _i++) {
            clearInterval(_this.intervals[_i]);
          }
        } else if (_this.completeInt > curr) {
          _this.completeInt = _this.completeInt - 1;
        } else {
          _this.completeInt = _this.completeInt + 1;
        }
      }, 100));
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      speechStorage: [],
      speechClass: {
        speechActive: false,
        invisibleAll: false
      }
    };
  },

  methods: {
    readSlide: function readSlide() {
      var _this = this;

      var browserSpeak = function browserSpeak(msg, idx) {
        if (typeof msg !== 'string') {
          throw new TypeError('Expected to say a string.');
        }
        var y = window.speechSynthesis;
        if (!y) {
          return console.warn('Your browser does not support `speechSynthesis` yet.');
        }
        var s = new SpeechSynthesisUtterance(msg);
        _this.speechStorage.push(s);
        s.voice = y.getVoices()[idx || 0];
        s.onstart = function () {
          _this.speechClass.speechActive = true;
        };
        s.onend = function () {
          _this.speechClass.speechActive = false;
          _this.speechStorage = [];
          _this.$store.commit('set_navigation_next', {
            text: 'next',
            custom: ''
          });
        };
        if (!_this.speechClass.speechActive) {
          y.speak(s);
        } else {
          y.cancel();
          _this.speechClass.speechActive = false;
          setTimeout(function () {
            _this.$store.commit('set_navigation_next', {
              text: 'next',
              custom: 'button-disabled'
            });
          }, 250);
        }
      };

      var textToSpeech = this.$store.state.pages[this.$store.state.page].textToSpeech;
      if (textToSpeech) {
        browserSpeak(textToSpeech, 0);
      }
    }
  },
  computed: {
    hasText: function hasText() {
      return this.$store.state.pages[this.$store.state.page].textToSpeech;
    }
  },
  watch: {
    hasText: function hasText() {
      this.speechClass.invisibleAll = !this.hasText ? true : false;
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__svg___default.a)
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_rollover_card__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__molecules_rollover_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__molecules_rollover_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__molecules_button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__molecules_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__molecules_button__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['bump'],
  components: {
    'rollover-card': __WEBPACK_IMPORTED_MODULE_0__molecules_rollover_card___default.a,
    'nav-button': __WEBPACK_IMPORTED_MODULE_1__molecules_button___default.a
  },
  computed: {
    span_computed: function span_computed() {
      if (this.bump.indexOf('down') !== -1) {
        return "span-6-lg offset-2-lg span-6-md offset-2-md span-14-sm offset-1-sm span-14-xs offset-1-xs max-100 " + this.bump;
      }
      return "span-6-lg offset-1-lg span-6-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs max-100 " + this.bump;
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__molecules_surveyCaption__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__molecules_surveyCaption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__molecules_surveyCaption__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['ind', 'caption'],
  data: function data() {
    return {
      error: false,
      current: null,
      options: ['Strongly Disagree', 'Somewhat Disagree', 'Neutral or No Opinion', 'Somewhat Agree', 'Strongly Agree']
    };
  },

  methods: {
    getFirstOption: function getFirstOption(index) {
      if (index < 1) {
        return 'offset-3-lg offset-1-md';
      } else {
        return '';
      }
    },
    checkIncompleteResponse: function checkIncompleteResponse() {
      if (!this.$store.state.postSurvey[this.storeGroup] && this.incompleteFlag) {
        this.error = true;
      } else {
        this.error = false;
      }
    },
    setOption: function setOption(optionInd) {
      if (this.current === optionInd) {
        this.current = null;
        this.$store.commit('setPostSurvey', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.storeGroup, false));
      } else {
        this.current = optionInd;
        this.$store.commit('setPostSurvey', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.storeGroup, true));

        this.$store.commit('setPostSurveyData', {
          question: this.caption,
          response: optionInd + 1
        });
      }

      this.checkIncompleteResponse();
    },
    isCurrent: function isCurrent(ind) {
      if (ind === this.current) {
        return 'hovered';
      } else {
        return '';
      }
    }
  },
  computed: {
    storeGroup: function storeGroup() {
      return 'postsurvey-' + this.ind + '-group';
    },
    incompleteFlag: function incompleteFlag() {
      return this.$store.state.postSurveyError;
    },
    hasError: function hasError() {
      if (this.error) {
        return 'border-error';
      }
      return '';
    }
  },
  watch: {
    incompleteFlag: function incompleteFlag() {
      this.checkIncompleteResponse();
    }
  },
  mounted: function mounted() {
    this.$store.commit('setPostSurvey', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.storeGroup, false));
  },

  components: {
    'survey-caption': __WEBPACK_IMPORTED_MODULE_1__molecules_surveyCaption___default.a
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_browser_speak__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_browser_speak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_browser_speak__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      speechText: 'Enter text here...',
      placeholder: 'Enter text here...',
      voiceOptions: [],
      voiceIndex: 0
    };
  },

  methods: {
    doThis: function doThis() {
      var queryValue = this.$refs.voiceSelect.value;
      this.voiceIndex = document.querySelector('option[value=\'' + queryValue + '\']').index;
    },
    readText: function readText() {
      __WEBPACK_IMPORTED_MODULE_0_browser_speak___default()(this.speechText, this.voiceIndex);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var populateVoices = function populateVoices() {
      var voices = window.speechSynthesis.getVoices();
      for (var i = 0; i < voices.length; i++) {
        _this.voiceOptions.push({
          title: voices[i].name + ' - ' + voices[i].lang,
          index: i
        });
      }
    };

    var pollForVoices = setInterval(function () {
      if (!_this.voiceOptions.length) {
        populateVoices();
      } else {
        clearInterval(pollForVoices);
      }
    }, 150);
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_api_addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_valid_email__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_valid_email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_valid_email__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.withCredentials = true;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      name: '',
      email: '',
      school: '',
      password: '',
      confirm_password: '',
      login_email: '',
      login_password: '',
      login_status: '',
      status: 'press enter or \'submit\' to save to db',
      default_status: 'press enter or \'submit\' to save to db',
      page_content: {},
      authorized: false,
      timeouts: []
    };
  },

  methods: {
    check_for_enter: function check_for_enter(e) {
      return e.keyCode === 13;
    },
    reset_fields: function reset_fields(bool) {
      if (bool) {
        this.name = '';
        this.email = '';
        this.school = '', this.password = '';
        this.confirm_password = '';
      }
      this.status = this.default_status;
    },
    enter_save_update: function enter_save_update(e) {
      if (this.check_for_enter(e)) {
        this.save_update();
      }
    },
    set_error: function set_error(msg) {
      var context = this;
      this.status = msg;
      for (var i = 0; i < this.timeouts.length; i++) {
        clearTimeout(this.timeouts[i]);
      }
      this.timeouts.push(setTimeout(function () {
        context.reset_fields();
      }, 2000));
      return false;
    },
    save_update: function save_update() {
      var context = this;

      if (!this.name || !this.email || !this.school || !this.password) {
        return this.set_error('please fill out all fields');
      }

      if (this.email && !__WEBPACK_IMPORTED_MODULE_1__utils_valid_email___default()(this.email)) {
        return this.set_error('please provide a valid email address');
      }

      if (this.password !== this.confirm_password) {
        return this.set_error('passwords do not match');
      }

      this.status = 'submitting';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__["devUrls"].server.register, {
        name: this.name,
        email: this.email,
        school: this.school,
        password: this.password
      }).then(function (response) {
        context.status = response.data;
        for (var i = 0; i < context.timeouts.length; i++) {
          clearTimeout(context.timeouts[i]);
        }
        context.timeouts.push(setTimeout(function () {
          context.reset_fields(true);
        }, 4000));
      }).catch(function (error) {
        context.status = 'error';
        for (var i = 0; i < context.timeouts.length; i++) {
          clearTimeout(context.timeouts[i]);
        }
        context.timeouts.push(setTimeout(function () {
          context.reset_fields();
        }, 2000));
      });
    },
    enter_login: function enter_login(e) {
      if (this.check_for_enter(e)) {
        this.login();
      }
    },
    login: function login() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__["devUrls"].server.login, {
        email: this.login_email,
        password: this.login_password
      }).then(function (response) {
        if (!response.data.authorized) {
          context.login_status = 'incorrect email or password';
        } else {
          context.page_content = response.data.user;
          context.authorized = response.data.authorized;
        }
      });
    },
    logout: function logout() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__["devUrls"].server.logout).then(function (response) {
        context.authorized = response.data.authorized;
        context.login_email = '';
        context.login_password = '';
      }).catch(function (err) {
        console.log(err);
      });
    },
    get_auth: function get_auth() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__["devUrls"].server.authenticate).then(function (response) {
        context.page_content = response.data.user;
        context.authorized = response.data.authorized;
      }).catch(function (err) {
        console.log(err);
      });
    },
    next_page: function next_page() {
      this.page_content.current_page = this.page_content.current_page + 1;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__["devUrls"].server.update, {
        current_page: this.page_content.current_page
      }).catch(function (err) {
        console.log(err);
      });
    },
    prev_page: function prev_page() {
      this.page_content.current_page = this.page_content.current_page - 1;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__utils_api_addresses__["devUrls"].server.update, {
        current_page: this.page_content.current_page
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    console.log('getting auth from page reload');
    this.get_auth();
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_navbar__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_organisms_navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_progressBar__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_progressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_organisms_progressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_organisms_pageBar__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_organisms_pageBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_organisms_pageBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_notification__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_organisms_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_organisms_login__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_organisms_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_organisms_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_organisms_landing__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_organisms_landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_organisms_landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_organisms_landingFirst__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_organisms_landingFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_organisms_landingFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_organisms_readButton__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_organisms_readButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_organisms_readButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contentful__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contentful___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__contentful__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isSurvey: '',
      landingFirstComplete: false
    };
  },

  computed: {
    loggedIn: function loggedIn() {
      return this.$store.state.loggedIn;
    },
    pages: function pages() {
      return this.$store.state.pages;
    },
    notification_state: function notification_state() {
      return this.$store.state.notification_state;
    },
    caption_state: function caption_state() {
      return this.$store.state.checkbox;
    },
    nextCondition: function nextCondition() {
      return this.$store.state.nextCondition;
    },
    percentComplete: function percentComplete() {
      var curr = this.$store.state.page;
      var len = this.$store.state.pages.length;
      return curr / len;
    },
    fullTemplate: function fullTemplate() {

      var defaultClasses = {
        gutter: '',
        progressHidden: false
      };

      if (!this.$store.state.pages[this.$store.state.page]) return defaultClasses;

      var fullTemplates = ['pre-survey', 'post-survey'];
      var currentTemplate = this.$store.state.pages[this.$store.state.page].template;

      for (var i = 0; i < fullTemplates.length; i++) {
        if (fullTemplates[i].indexOf(currentTemplate) !== -1) {
          return {
            gutter: 'gutter-full',
            progressHidden: true
          };
        }
      }

      return defaultClasses;
    }
  },
  methods: {
    landingFirstCompleteCb: function landingFirstCompleteCb() {
      this.landingFirstComplete = true;
    },
    slide_active: function slide_active(page) {
      var current_page = this.$store.state.page;
      if (current_page !== page) {
        return {
          class: 'page-inactive',
          bool: false
        };
      } else {
        return {
          class: '',
          bool: true
        };
      }
    },
    slide_in_queue: function slide_in_queue(this_page) {
      var current_page = this.$store.state.page;

      if (this_page < current_page - 1 || this_page > current_page + 1) {
        return 'hide-all';
      } else {
        return '';
      }
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    navbar: __WEBPACK_IMPORTED_MODULE_1__components_organisms_navbar___default.a,
    notification: __WEBPACK_IMPORTED_MODULE_4__components_organisms_notification___default.a,
    login: __WEBPACK_IMPORTED_MODULE_5__components_organisms_login___default.a,
    'progress-bar': __WEBPACK_IMPORTED_MODULE_2__components_organisms_progressBar___default.a,
    'page-bar': __WEBPACK_IMPORTED_MODULE_3__components_organisms_pageBar___default.a,
    'landing-screen': __WEBPACK_IMPORTED_MODULE_6__components_organisms_landing___default.a,
    'landing-first': __WEBPACK_IMPORTED_MODULE_7__components_organisms_landingFirst___default.a
  }, __WEBPACK_IMPORTED_MODULE_9__pages___default.a, {
    readButton: __WEBPACK_IMPORTED_MODULE_8__components_organisms_readButton___default.a
  }),
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_10__contentful___default()(this, 'set_pages');
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_radio_span__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_radio_span___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_radio_span__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_is_active__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_is_active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_is_active__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nodelist_foreach_polyfill__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nodelist_foreach_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nodelist_foreach_polyfill__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'content', 'active'],
  components: {
    'full-span-slide': __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide___default.a,
    'radio-span': __WEBPACK_IMPORTED_MODULE_1__components_molecules_radio_span___default.a
  },
  methods: {
    conditional: function conditional() {
      return this.active && !this.$store.state.checkbox.el;
    }
  },
  watch: {
    active: function active() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_is_active__["is_active"])(this, this.conditional());
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_flip_card__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_flip_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_flip_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_header_block__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_header_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_organisms_header_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_active__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_is_active__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nodelist_foreach_polyfill__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_nodelist_foreach_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_nodelist_foreach_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar__ = __webpack_require__(49);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'content', 'active'],
  components: {
    'header-block': __WEBPACK_IMPORTED_MODULE_1__components_organisms_header_block___default.a,
    'flip-card': __WEBPACK_IMPORTED_MODULE_0__components_molecules_flip_card___default.a
  },
  data: function data() {
    return {
      flipped: 0,
      psOne: null
    };
  },

  methods: {
    scrollBarInit: function scrollBarInit() {
      if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
        var containerOne = this.$refs.scrollHookOne;
        this.psOne = new __WEBPACK_IMPORTED_MODULE_5_perfect_scrollbar__["a" /* default */](containerOne);
      } else if (window.innerWidth <= 1200 && this.psOne || window.innerHeight <= 600 && this.psOne) {
        this.psOne.destroy();
        this.psOne = null;
      }
      window.addEventListener('resize', this.scrollBarInit);
    },
    change_flip_count: function change_flip_count(inc) {
      this.flipped += inc;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_is_active__["is_active"])(this, this.conditional());
    },
    conditional: function conditional() {
      return this.active && this.flipped < this.content.cards.length;
    },
    activeCallback: function activeCallback() {
      var _this = this;

      var int = 800;
      if (this.active) {
        setTimeout(function () {
          _this.scrollBarInit();
        }, int);
        setTimeout(function () {
          if (_this.psOne) _this.psOne.update();
        }, int + 1000);
      }
    }
  },
  computed: {
    card_size: function card_size() {
      return this.content.cards.length;
    },
    markedCards: function markedCards() {
      if (this.content.cards) {
        return this.content.cards.map(function (card) {
          return {
            paragraph: __WEBPACK_IMPORTED_MODULE_2_marked___default()(card.paragraph),
            icon: card.icon,
            title: card.title
          };
        });
      }
    }
  },
  mounted: function mounted() {
    this.activeCallback();
  },

  watch: {
    active: function active() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_is_active__["is_active"])(this, this.conditional());
      this.activeCallback();
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_active__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_is_active__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'content', 'active'],
  data: function data() {
    return {
      showCaptionClass: 'invisible'
    };
  },

  methods: {
    keyCallback: function keyCallback(e) {
      var _this = this;

      if (this.$refs.textarea.value.length) {
        this.showCaptionClass = '';
      } else {
        this.showCaptionClass = 'invisible';
      }

      if (e.keyCode === 13) {
        setTimeout(function () {
          _this.$store.commit('change_page', 1);
        }, 250);
      }
    }
  },
  computed: {
    markedParagraphs: function markedParagraphs() {
      if (this.content.paragraphs) {
        return this.content.paragraphs.map(function (paragraph) {
          return __WEBPACK_IMPORTED_MODULE_1_marked___default()(paragraph);
        });
      }
    }
  },
  components: {
    'full-span-slide': __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide___default.a
  },
  watch: {
    active: function active() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_is_active__["is_active"])(this, false);
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_overflow_image_slide__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_overflow_image_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_organisms_overflow_image_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_active__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_is_active__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'content', 'active'],
  components: {
    'overflow-image-slide': __WEBPACK_IMPORTED_MODULE_0__components_organisms_overflow_image_slide___default.a
  },
  computed: {
    markedParagraphs: function markedParagraphs() {
      if (this.content.paragraphs) {
        return this.content.paragraphs.map(function (paragraph) {
          return __WEBPACK_IMPORTED_MODULE_1_marked___default()(paragraph);
        });
      }
    }
  },
  watch: {
    active: function active() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_is_active__["is_active"])(this, false);
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_surveyResponse__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_surveyResponse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_organisms_surveyResponse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_progressBar__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_organisms_progressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_organisms_progressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_vanilla_smooth_scroll__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_vanilla_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_vanilla_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_addresses__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api_addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_api_addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);










__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.withCredentials = true;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['active'],
  data: function data() {
    return {
      captions: ['Increased my level of commitment to change the way I interact with children who are exhibiting the effects of trauma.', 'Made me feel better prepared to work with students who may have been exposed to violence and trauma.', 'Inspires me to work at my school/district to promote a more compassionate and safer school environment for students, parents, teachers, and staff.', 'Has content that is relevant to my work.', 'Made me interested in a more indepth training on this topic.'],
      psOne: null
    };
  },

  methods: {
    checkIncompleteSurvey: function checkIncompleteSurvey() {
      var bool = false;
      var postSurvey = this.$store.state.postSurvey;

      for (var key in postSurvey) {
        if (!postSurvey[key]) {
          bool = true;
        }
      }

      return bool;
    },
    scrollBarInit: function scrollBarInit() {
      if (window.innerWidth > 1200 && !this.psOne) {
        var containerOne = this.$refs.scrollContainer;
        this.psOne = new __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__["a" /* default */](containerOne);
      } else if (this.psOne) {
        this.psOne.destroy();
        this.psOne = null;
      }
      window.addEventListener('resize', this.scrollBarInit);
    },
    setNextCallback: function setNextCallback() {
      var _this = this;

      if (this.active) {
        var nextButtonCallback = function nextButtonCallback() {
          if (_this.checkIncompleteSurvey()) {
            _this.$store.commit('setPostSurveyError', true);
            setTimeout(function () {
              if (window.innerWidth < 1200) {
                __WEBPACK_IMPORTED_MODULE_2__utils_vanilla_smooth_scroll___default()(0, 1200);
              } else {
                __WEBPACK_IMPORTED_MODULE_2__utils_vanilla_smooth_scroll___default()(0, 1200, null, _this.$refs.scrollContainer);
              }
            }, 800);
            return false;
          } else {
            console.log('post survey complete.');
            console.log(_this.$store.state.postSurveyData);
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__utils_api_addresses__["apiUrls"].server.postSurvey, _this.$store.state.postSurveyData).catch(function (err) {
              console.log(err);
            });

            return true;
          }
        };

        this.$store.commit('setNextCondition', nextButtonCallback);

        setTimeout(function () {
          _this.scrollBarInit();
        }, 1000);
      }
    }
  },
  computed: {
    postSurveyError: function postSurveyError() {
      return this.$store.state.postSurveyError;
    }
  },
  mounted: function mounted() {
    this.setNextCallback();
  },

  watch: {
    active: function active() {
      this.setNextCallback();
    }
  },
  components: {
    'response': __WEBPACK_IMPORTED_MODULE_0__components_organisms_surveyResponse___default.a,
    'progress-bar': __WEBPACK_IMPORTED_MODULE_1__components_organisms_progressBar___default.a
  }

});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_surveyCaption__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_surveyCaption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_surveyCaption__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_radio_span__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_radio_span___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_radio_span__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_full_span_slide__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_full_span_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_organisms_full_span_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_vanilla_smooth_scroll__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_vanilla_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__utils_vanilla_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_perfect_scrollbar__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api_addresses__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api_addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utils_api_addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_polyfill__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);













__WEBPACK_IMPORTED_MODULE_9_axios___default.a.defaults.withCredentials = true;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['active'],
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      showErrorMessage: false,
      modifyDOMFlag: false,
      psOne: null,
      otherText: ''
    }, this.initData());
  },

  methods: {
    initData: function initData() {
      var data = {};
      var validations = 6;
      for (var i = 0; i < validations; i++) {
        data['presurvey_' + i + '_group'] = '';
      }
      return data;
    },
    textToStore: function textToStore(r, question, textAreaFlag) {
      textAreaFlag = textAreaFlag || false;
      var bool = true;
      if (!this.$refs[r].value.length) {
        bool = false;
      }
      this.$store.commit('setPreSurvey', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, r, bool));
      if (!textAreaFlag) {
        this.$store.commit('setPreSurveyData', {
          question: question,
          response: this.$refs[r].value
        });
      } else {
        this.$store.commit('setPreSurveyData', {
          question: 'What position do you hold? (Other)',
          response: this.otherText
        });
      }
    },
    checkIncompleteSurvey: function checkIncompleteSurvey(options) {
      options = options || {
        modifyDOM: false
      };
      var validations = 6;
      var bool = false;
      this.showErrorMessage = false;

      for (var i = 0; i < validations; i++) {
        if (!this.$store.state.preSurvey['presurvey-' + i + '-group']) {
          bool = true;

          if (options.modifyDOM || this.modifyDOMFlag) {
            this.modifyDOMFlag = true;
            this.showErrorMessage = true;
            this['presurvey_' + i + '_group'] = 'border-error';
          }
        } else {
          this['presurvey_' + i + '_group'] = '';
        }
      }

      return bool;
    },
    scrollBarInit: function scrollBarInit() {
      if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
        var containerOne = this.$refs.scrollContainer;
        this.psOne = new __WEBPACK_IMPORTED_MODULE_6_perfect_scrollbar__["a" /* default */](containerOne);
      } else if (this.psOne) {
        this.psOne.destroy();
        this.psOne = null;
      }
      window.addEventListener('resize', this.scrollBarInit);
    },
    activeCallback: function activeCallback() {
      var _this = this;

      if (this.active) {
        var nextButtonCallback = function nextButtonCallback() {
          if (_this.checkIncompleteSurvey({
            modifyDOM: true
          })) {
            setTimeout(function () {
              if (window.innerWidth < 1200) {
                __WEBPACK_IMPORTED_MODULE_5__utils_vanilla_smooth_scroll___default()(0, 1200);
              } else {
                __WEBPACK_IMPORTED_MODULE_5__utils_vanilla_smooth_scroll___default()(0, 1200, null, _this.$refs.scrollContainer);
              }
            }, 800);

            return false;
          } else {
            console.log('pre survey complete.');
            console.log(_this.$store.state.preSurveyData);
            __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7__utils_api_addresses__["apiUrls"].server.preSurvey, _this.$store.state.preSurveyData).catch(function (err) {
              console.log(err);
            });

            return true;
          }
        };

        this.$store.commit('setNextCondition', nextButtonCallback);

        setTimeout(function () {
          _this.scrollBarInit();
        }, 1000);
      }
    }
  },
  computed: {
    preSurveyChange: function preSurveyChange() {
      return this.$store.state.preSurvey.changeTrigger;
    }
  },
  components: {
    'full-span-slide': __WEBPACK_IMPORTED_MODULE_4__components_organisms_full_span_slide___default.a,
    'survey-caption': __WEBPACK_IMPORTED_MODULE_2__components_molecules_surveyCaption___default.a,
    'radio-span': __WEBPACK_IMPORTED_MODULE_3__components_molecules_radio_span___default.a
  },
  mounted: function mounted() {
    this.activeCallback();
  },

  watch: {
    active: function active() {
      this.activeCallback();
    },
    preSurveyChange: function preSurveyChange() {
      this.checkIncompleteSurvey();
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_progress_selector__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_progress_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_progress_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_rollover_card__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_rollover_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_rollover_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_organisms_header_block__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_organisms_header_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_organisms_header_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_atoms_crosshair_background__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_atoms_crosshair_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_atoms_crosshair_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_atoms_arrow__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_atoms_arrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_atoms_arrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_svg__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_atoms_spacer__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_atoms_spacer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_atoms_spacer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_vanilla_smooth_scroll__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_vanilla_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__utils_vanilla_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ratio_height__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ratio_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__utils_ratio_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_is_active__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_is_active___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__utils_is_active__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_marked__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_perfect_scrollbar__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nodelist_foreach_polyfill__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_nodelist_foreach_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_nodelist_foreach_polyfill__);




















/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'content', 'active'],
  data: function data() {
    return {
      card: null,
      offset_index: 0,
      multiplier: 84,
      ratio_styles: __WEBPACK_IMPORTED_MODULE_9__utils_ratio_height__["ratio_styles"],
      indicatorClass: 'indicator-not-in-view',
      indicatorVisibleClass: 'indicator-invisible',
      contentActiveClass: 'content-inactive',
      containerRef: null,
      timeouts: [],
      psOne: null,
      psTwo: null
    };
  },

  methods: {
    createMarked: function createMarked(str) {
      return __WEBPACK_IMPORTED_MODULE_11_marked___default()(str);
    },
    set_card: function set_card(content, index) {
      this.card = content;
      this.offset_index += 1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_is_active__["is_active"])(this, this.conditional());
    },
    selectorCallback: function selectorCallback(c, i) {
      var _this = this;

      this.indicatorVisibleClass = 'indicator-invisible';

      for (var _i = 0; _i < this.timeouts.length; _i++) {
        clearTimeout(this.timeouts[_i]);
      }

      this.timeouts.push(setTimeout(function () {
        _this.indicatorVisibleClass = '';
        _this.set_card(c, i);
      }, 400), setTimeout(function () {
        var containerTwo = _this.$refs.scrollHookTwo;
        _this.psTwo.update();
        __WEBPACK_IMPORTED_MODULE_8__utils_vanilla_smooth_scroll___default()(0, 150, null, containerTwo);
      }, 600));

      if (this.indicatorClass !== '') {
        this.toggleIndicator();
      }
    },
    conditional: function conditional() {
      return this.active && this.offset_index < this.content.cards.length;
    },
    toggleIndicator: function toggleIndicator() {
      if (this.indicatorClass === '') {
        this.indicatorClass = 'indicator-not-in-view';
      } else {
        this.indicatorClass = '';
      }
    },
    ratioInit: function ratioInit() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_ratio_height__["ratio_height"])(this, this.$refs.selectorCard, 4 / 3);
      window.addEventListener('resize', function () {
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_ratio_height__["ratio_height"])(_this2, '[container-card="selector-card"]', 4 / 3);
        }, 500);
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_ratio_height__["ratio_height"])(_this2, '[container-card="selector-card"]', 4 / 3);
        }, 1000);
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_ratio_height__["ratio_height"])(_this2, '[container-card="selector-card"]', 4 / 3);
        }, 1500);
      });
    },
    scrollBarInit: function scrollBarInit() {
      if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
        var containerOne = this.$refs.scrollHookOne;
        var containerTwo = this.$refs.scrollHookTwo;
        this.psOne = new __WEBPACK_IMPORTED_MODULE_12_perfect_scrollbar__["a" /* default */](containerOne);
        this.psTwo = new __WEBPACK_IMPORTED_MODULE_12_perfect_scrollbar__["a" /* default */](containerTwo);
      } else if (window.innerWidth <= 1200 && this.psOne || window.innerHeight <= 600 && this.psOne) {
        this.psOne.destroy();
        this.psTwo.destroy();
        this.psOne = null;
        this.psTwo = null;
      }
      window.addEventListener('resize', this.scrollBarInit);
    },
    activeCallback: function activeCallback() {
      var _this3 = this;

      var int = 800;
      if (this.active) {
        setTimeout(function () {
          _this3.ratioInit();
          _this3.scrollBarInit();
          _this3.contentActiveClass = '';
        }, int);
        setTimeout(function () {
          if (_this3.psOne) _this3.psOne.update();
        }, int + 1000);
      } else {
        setTimeout(function () {
          _this3.contentActiveClass = 'content-inactive';
        }, int);
      }
    }
  },
  computed: {
    transform_style: function transform_style() {
      var offset = this.offset_index * this.multiplier - this.multiplier;
      return {
        'transform': 'translateY(-' + offset + 'px)'
      };
    },
    markedCard: function markedCard() {
      if (this.card) {
        return {
          title: __WEBPACK_IMPORTED_MODULE_11_marked___default()(this.card.title),
          paragraph: __WEBPACK_IMPORTED_MODULE_11_marked___default()(this.card.paragraph)
        };
      }
    },
    hasContentClass: function hasContentClass() {
      if (this.card) {
        return 'hovered';
      }
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    'progress-selector': __WEBPACK_IMPORTED_MODULE_1__components_molecules_progress_selector___default.a,
    'rollover-card': __WEBPACK_IMPORTED_MODULE_2__components_molecules_rollover_card___default.a,
    'header-block': __WEBPACK_IMPORTED_MODULE_3__components_organisms_header_block___default.a,
    'crosshair-background': __WEBPACK_IMPORTED_MODULE_4__components_atoms_crosshair_background___default.a,
    'arrow': __WEBPACK_IMPORTED_MODULE_5__components_atoms_arrow___default.a,
    spacer: __WEBPACK_IMPORTED_MODULE_7__components_atoms_spacer___default.a
  }, __WEBPACK_IMPORTED_MODULE_6__components_svg___default.a),
  watch: {
    active: function active() {
      this.activeCallback();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_is_active__["is_active"])(this, this.conditional());
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ratio_height__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ratio_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utils_ratio_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_nodelist_foreach_polyfill__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'content', 'active'],
  data: function data() {
    return {
      ratio_styles: __WEBPACK_IMPORTED_MODULE_1__utils_ratio_height__["ratio_styles"]
    };
  },

  methods: {
    lg_offset: function lg_offset(ind) {
      if (ind > 0) {
        return 'offset-2-lg';
      }
      return 'offset-1-lg transform-up';
    },
    ratioInit: function ratioInit() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ratio_height__["ratio_height"])(this, '[container-card="share-card"]', 1 / 1.25);
      window.addEventListener('resize', function () {
        setTimeout(function () {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ratio_height__["ratio_height"])(_this, '[container-card="share-card"]', 1 / 1.25);
        }, 500);
      });
    },
    activeCallback: function activeCallback() {
      if (this.active) {
        this.ratioInit();
      }
    }
  },
  components: {
    'nav-button': __WEBPACK_IMPORTED_MODULE_0__components_molecules_button___default.a
  },
  watch: {
    active: function active() {
      this.activeCallback();
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nodelist_foreach_polyfill__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nodelist_foreach_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nodelist_foreach_polyfill__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['title', 'content', 'active'],
  components: {
    'full-span-slide': __WEBPACK_IMPORTED_MODULE_0__components_organisms_full_span_slide___default.a
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_full_span_slide__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organisms_full_span_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_organisms_full_span_slide__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__pages___default.a, {
    'full-span-slide': __WEBPACK_IMPORTED_MODULE_2__components_organisms_full_span_slide___default.a
  })
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_span_background__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_atoms_span_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_atoms_span_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_crosshair_background__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_atoms_crosshair_background___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_atoms_crosshair_background__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_atoms_radio__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_atoms_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_atoms_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_atoms_arrow__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_atoms_arrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_atoms_arrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_atoms_image_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_atoms_image_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_atoms_image_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_atoms_video_component__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_atoms_video_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_atoms_video_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_svg__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_svg__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    'span-background': __WEBPACK_IMPORTED_MODULE_1__components_atoms_span_background___default.a,
    'crosshair-background': __WEBPACK_IMPORTED_MODULE_2__components_atoms_crosshair_background___default.a,
    'radio': __WEBPACK_IMPORTED_MODULE_3__components_atoms_radio___default.a,
    'arrow': __WEBPACK_IMPORTED_MODULE_4__components_atoms_arrow___default.a,
    'image-component': __WEBPACK_IMPORTED_MODULE_5__components_atoms_image_component___default.a,
    'video-component': __WEBPACK_IMPORTED_MODULE_6__components_atoms_video_component___default.a
  }, __WEBPACK_IMPORTED_MODULE_7__components_svg___default.a),
  data: function data() {
    return {
      current_svg: 'correct',
      example_image: 'https://s3-us-west-2.amazonaws.com/fwov-vpv/temp.png',
      example_video: 'https://www.youtube.com/watch?v=rV1xGALlamg'
    };
  },

  computed: {
    svg_list: function svg_list() {
      var temp = [];
      for (var key in __WEBPACK_IMPORTED_MODULE_7__components_svg___default.a) {
        temp.push(key);
      }
      return temp;
    }
  },
  methods: {
    change_svg: function change_svg(svg) {
      var el = document.querySelector('[svg-select]');
      this.current_svg = el.value;
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lorem_ipsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus lacinia tempor ante, eget pellentesque risus pharetra vel. Proin sit amet maximus erat, vestibulum fermentum nunc. Donec viverra pulvinar orci ac vehicula. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum commodo nec magna at vestibulum.'
    };
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_flip_card__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_flip_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_flip_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_progress_selector__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_molecules_progress_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_molecules_progress_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_popup_notification__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_molecules_popup_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_molecules_popup_notification__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'nav-button': __WEBPACK_IMPORTED_MODULE_0__components_molecules_button___default.a,
    'rollover-card': __WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card___default.a,
    'flip-card': __WEBPACK_IMPORTED_MODULE_2__components_molecules_flip_card___default.a,
    'progress-selector': __WEBPACK_IMPORTED_MODULE_3__components_molecules_progress_selector___default.a,
    'popup-notification': __WEBPACK_IMPORTED_MODULE_4__components_molecules_popup_notification___default.a
  },
  data: function data() {
    return {
      popup_text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.'
    };
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_radio_span__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_molecules_radio_span___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_molecules_radio_span__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_progress_selector__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_molecules_progress_selector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_molecules_progress_selector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_organisms_navbar__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_organisms_navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_organisms_navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_overflow_image_slide__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_organisms_overflow_image_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_organisms_overflow_image_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_organisms_full_span_slide__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_organisms_full_span_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_organisms_full_span_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_organisms_header_block__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_organisms_header_block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_organisms_header_block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_organisms_share_card__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_organisms_share_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_organisms_share_card__);













/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      example_image: 'https://s3-us-west-2.amazonaws.com/fwov-vpv/temp.png'
    };
  },

  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_3__components_organisms_navbar___default.a,
    'overflow-image-slide': __WEBPACK_IMPORTED_MODULE_4__components_organisms_overflow_image_slide___default.a,
    'full-span-slide': __WEBPACK_IMPORTED_MODULE_5__components_organisms_full_span_slide___default.a,
    'radio-span': __WEBPACK_IMPORTED_MODULE_0__components_molecules_radio_span___default.a,
    'header-block': __WEBPACK_IMPORTED_MODULE_6__components_organisms_header_block___default.a,
    'share-card': __WEBPACK_IMPORTED_MODULE_7__components_organisms_share_card___default.a,
    'rollover-card': __WEBPACK_IMPORTED_MODULE_1__components_molecules_rollover_card___default.a,
    'progress-selector': __WEBPACK_IMPORTED_MODULE_2__components_molecules_progress_selector___default.a
  }
});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  space: 'ows9csc2fuk9',
  accessToken: 'c57b6a0b3d42af3e38b9b7532d57cc51e93cfe20c411c81d7c0057e882f71438'
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(26);

var _extends3 = _interopRequireDefault(_extends2);

var _contentful = __webpack_require__(270);

var contentful = _interopRequireWildcard(_contentful);

var _contentful_keys = __webpack_require__(260);

var _contentful_keys2 = _interopRequireDefault(_contentful_keys);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = contentful.createClient(_contentful_keys2.default);

exports.default = function (context, mutation) {

  client.getEntries({
    'content_type': 'allPages',
    include: 5 }).then(function (entries) {

    var pages = entries.items[0].fields.pages.map(function (item) {

      var template = item.fields.template.sys.contentType.sys.id;
      var content = item.fields.template.fields;
      var new_content = {};
      var image = null;
      var video = null;
      var align = null;
      var text_box = null;
      var pdf = null;
      var videoFile = null;
      var textToSpeech = null;

      var _loop = function _loop(key) {
        if (Array.isArray(content[key])) {
          var content_fields = content[key].map(function (entry) {
            if (key === 'paragraphs') return entry.fields.text;
            return entry.fields;
          });
          new_content[key] = content_fields;
        }
      };

      for (var key in content) {
        _loop(key);
      }

      if (item.fields.image) image = item.fields.image.fields.file.url;
      if (item.fields.video) video = item.fields.video;
      if (item.fields.align) align = item.fields.align;
      if (item.fields.text_box) text_box = item.fields.text_box;
      if (item.fields.pdf) pdf = item.fields.pdf.fields.file.url;
      if (item.fields.textToSpeech) textToSpeech = item.fields.textToSpeech;

      if (item.fields.videoFile) {
        videoFile = item.fields.videoFile.fields.file.url;
      }

      return {
        title: item.fields.title,
        template: template,
        content: (0, _extends3.default)({}, new_content, {
          image: image,
          video: video,
          videoFile: videoFile,
          align: align,
          text_box: text_box,
          pdf: pdf
        }),
        textToSpeech: textToSpeech
      };
    });

    var first_pages = [{
      content: {
        image: null,
        video: null,
        align: null,
        text_box: null,
        pdf: null
      },
      title: 'Pre Survey',
      template: 'pre-survey'
    }];

    var last_pages = [{
      content: {
        image: null,
        video: null,
        align: null,
        text_box: null,
        pdf: null
      },
      title: 'Post Survey',
      template: 'post-survey'
    }, {
      content: {
        image: null,
        video: null,
        align: null,
        text_box: null,
        pdf: null
      },
      title: 'Sponsors',
      template: 'sponsor-page'
    }];

    pages = first_pages.concat(pages).concat(last_pages);

    context.$store.commit(mutation, pages);
  });
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(93);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(199);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(196);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(197);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth_sandbox = __webpack_require__(574);

var _auth_sandbox2 = _interopRequireDefault(_auth_sandbox);

var _sandbox = __webpack_require__(585);

var _sandbox2 = _interopRequireDefault(_sandbox);

var _audio = __webpack_require__(573);

var _audio2 = _interopRequireDefault(_audio);

var _main = __webpack_require__(588);

var _main2 = _interopRequireDefault(_main);

var _fonts = __webpack_require__(587);

var _fonts2 = _interopRequireDefault(_fonts);

var _atoms = __webpack_require__(586);

var _atoms2 = _interopRequireDefault(_atoms);

var _molecules = __webpack_require__(589);

var _molecules2 = _interopRequireDefault(_molecules);

var _organisms = __webpack_require__(590);

var _organisms2 = _interopRequireDefault(_organisms);

var _main3 = __webpack_require__(575);

var _main4 = _interopRequireDefault(_main3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  main: _main4.default,
  auth_sandbox: _auth_sandbox2.default,
  sandbox: _sandbox2.default,
  audio: _audio2.default,
  style_guide: {
    main: _main2.default,
    fonts: _fonts2.default,
    atoms: _atoms2.default,
    molecules: _molecules2.default,
    organisms: _organisms2.default
  }
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  this.$emit('clicked');
};

/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-94e185de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b9dc4a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36be98bf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cc86951a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(614),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d9669d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-96e8a1e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54f64b64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(673),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fdc4ad54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ed66321",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(630),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(604),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(627),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(653),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(641),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(668),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(638),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(662),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(607),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(657),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(634),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(616),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(646),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(635),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(636),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(637),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(647),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(601),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(611),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(672),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(619),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(666),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(652),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(640),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(621),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(654),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(651),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(659),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b74d82c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(617),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44c9bd12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8be68300",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(649),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(628),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(642),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(643),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f036357",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(517)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9ee86c26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(664),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cbc1e03e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a9c51ef4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(623),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1932faac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(658),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-850febfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(615),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42f2fbc9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar ind-4",
    class: _vm.navActive,
    on: {
      "mouseenter": _vm.setNavActive,
      "mouseleave": _vm.removeNavActive
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('nav-button', {
    attrs: {
      "type": "back",
      "clickevent": _vm.back_click,
      "customclass": [_vm.back.custom, _vm.navActive]
    }
  }, [_vm._v(_vm._s(_vm.back.text))]), _vm._v(" "), _c('a', {
    staticClass: "content-translate pdf-link",
    class: [_vm.hasPDF, _vm.navActive],
    attrs: {
      "href": _vm.pdf,
      "target": "blank"
    }
  }, [_c('download-svg'), _vm._v(" "), _c('span', {
    staticClass: "hide-sm"
  }, [_vm._v("Download")]), _vm._v(" PDF\n    ")], 1), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "next",
      "clickevent": _vm.next_click,
      "customclass": [_vm.next.custom, _vm.navActive]
    }
  }, [_vm._v(_vm._s(_vm.next.text))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("molecules")]), _vm._v(" "), _c('h2', [_vm._v("buttons")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-16-lg"
  }, [_c('nav-button', {
    attrs: {
      "type": "next"
    }
  }, [_vm._v("next")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "back"
    }
  }, [_vm._v("back")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "share"
    }
  }, [_vm._v("share")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "call-to-action"
    }
  }, [_vm._v("begin")]), _vm._v(" "), _c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "button-disabled"
    }
  }, [_vm._v("submit")])], 1)]), _vm._v(" "), _c('h2', [_vm._v("card with rollover")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('rollover-card', {
    attrs: {
      "spanclass": "span-4-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs",
      "ratioclass": "ratio-flip-card"
    }
  }, [_vm._v("content here")])], 1), _vm._v(" "), _c('h2', [_vm._v("Card with 3D flip effect and rollover")]), _vm._v(" "), _c('p', [_vm._v("(click to rotate)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('flip-card', {
    attrs: {
      "icon": "culture"
    }
  }), _vm._v(" "), _c('flip-card', {
    attrs: {
      "icon": "role-models"
    }
  }), _vm._v(" "), _c('flip-card', {
    attrs: {
      "icon": "networks"
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("progress selectors (click in order)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-9-lg offset-1-lg span-8-md overflow-hidden"
  }, [_c('progress-selector', [_vm._v("first")]), _vm._v(" "), _c('progress-selector', [_vm._v("second")]), _vm._v(" "), _c('progress-selector', [_vm._v("third")]), _vm._v(" "), _c('progress-selector', [_vm._v("fourth")])], 1)]), _vm._v(" "), _c('h2', [_vm._v("popup notification")]), _vm._v(" "), _c('h3', [_vm._v("correct")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('popup-notification', {
    attrs: {
      "type": "correct",
      "title": "you've got it!"
    }
  }, [_vm._v(_vm._s(_vm.popup_text))])], 1), _vm._v(" "), _c('h3', [_vm._v("incorrect")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('popup-notification', {
    attrs: {
      "type": "incorrect",
      "title": "not quite"
    }
  }, [_vm._v(_vm._s(_vm.popup_text))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar-container hide-sm",
    class: _vm.isHidden
  }, [_c('div', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.completeInt) + "% complete")]), _vm._v(" "), _c('div', {
    staticClass: "bar-outer"
  }, [_c('div', {
    staticClass: "bar-progress",
    style: (_vm.barSize)
  })])])
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-selector-wrapper",
    style: ([_vm.transform, _vm.active_class])
  }, [_c('input', {
    staticClass: "progress-selector-indicator ind-2",
    class: _vm.selectorClass,
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.selectorClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-selector-content ind-1 border-bg-rollover"
  }, [_c('div', {
    staticClass: "p max-96"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "next"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill red"
  }, [_c('polygon', {
    attrs: {
      "points": "10 16.6442673 21.6215729 5 34.993837 18.4271679 48.4139472 5.03389696 60 16.6278485 46.5938062 30.0462773 59.9749504 43.3725488 48.4551665 54.9484925 35.015043 41.631887 21.6264768 55 10.0299535 43.4147875 23.3871083 30.0302557"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs",
    class: _vm.popup_border
  }, [_c('div', {
    staticClass: "notification-content"
  }, [_c('div', {
    staticClass: "notification-svg hide-sm"
  }, [_c(_vm.is_correct, {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "notification-svg-mobile show-sm notification-svg-sm"
  }, [_c(_vm.is_correct, {
    tag: "component"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "subheader upcase"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Plus-black",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,24 L6,24 L6,22 L2.08571429,22 L2.08571429,2 L6,2 L6,0 L0,0 L0,24 Z M16.9990234,18 L19,18 L19,13 L24,13 L24,11 L19,11 L19,6 L16.9990234,6 L16.9990234,11 L12,11 L12,13 L16.9990234,13 L16.9990234,18 Z M30,24 L36,24 L36,0 L30,0 L30,2 L34,2 L34,22 L30,22 L30,24 Z",
      "id": "[+]"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extra-padding-bottom"
  }, [_c('h2', [_vm._v("Atoms")]), _vm._v(" "), _c('h2', [_vm._v("Solid Border")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Hatch Background")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_vm._m(1), _vm._v(" "), _c('span-background')], 1)]), _vm._v(" "), _c('h2', [_vm._v("Gradient Background")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Crosshair Background")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_vm._m(3), _vm._v(" "), _c('crosshair-background')], 1)]), _vm._v(" "), _c('h2', [_vm._v("Combined Hatch/Crosshair")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_vm._m(4), _vm._v(" "), _c('crosshair-background'), _vm._v(" "), _c('span-background')], 1)]), _vm._v(" "), _c('h2', [_vm._v("Image")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('image-component', {
    attrs: {
      "image": _vm.example_image
    }
  })], 1)])]), _vm._v(" "), _c('h2', [_vm._v("Video")]), _vm._v(" "), _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative"
  }, [_c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('video-component', {
    attrs: {
      "video": _vm.example_video
    }
  })], 1)])]), _vm._v(" "), _c('h2', [_vm._v("Static SVGs/SVG Icons")]), _vm._v(" "), _c('div', [_c(_vm.current_svg, {
    tag: "component"
  })], 1), _vm._v(" "), _c('h3', [_vm._v("select from dropdown")]), _vm._v(" "), _c('select', {
    attrs: {
      "svg-select": ""
    },
    on: {
      "change": _vm.change_svg
    }
  }, _vm._l((_vm.svg_list), function(component) {
    return _c('option', {
      key: component
    }, [_vm._v(_vm._s(component))])
  })), _vm._v(" "), _c('h2', [_vm._v("Radio Buttons")]), _vm._v(" "), _c('radio'), _vm._v(" "), _c('radio', {
    attrs: {
      "type": "incorrect"
    }
  }), _vm._v(" "), _c('radio', {
    attrs: {
      "type": "correct"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Arrows")]), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "next"
    }
  }), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "prev"
    }
  }), _vm._v(" "), _c('arrow', {
    attrs: {
      "type": "plus"
    }
  }), _vm._v(" "), _vm._m(5)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row debug"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md relative border-blue"
  }, [_c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-6-lg offset-5-lg span-6-md offset-5-md bg-gradient ratio-4-3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ratio-4-3 debug"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ratio-4-3 ind-2"
  }, [_c('h1', [_vm._v("Content")]), _vm._v(" "), _c('p', [_vm._v("Lorem Ipsum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-example ind-top"
  }, [_c('h3', [_vm._v("navbar")])])
}]}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border-error-container",
    class: _vm.hasError
  }, [_c('survey-caption', {
    attrs: {
      "ind": _vm.ind
    }
  }, [_vm._v(_vm._s(_vm.caption))]), _vm._v(" "), _c('div', {
    staticClass: "row survey-options-container center-flex-mobile"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "span-2-lg span-3-md span-3-sm span-3-xs relative survey-option-outer ratio-survey-card",
      class: _vm.getFirstOption(index)
    }, [_c('div', {
      ref: index,
      refInFor: true,
      staticClass: "survey-option-inner text-center",
      class: _vm.isCurrent(index),
      on: {
        "click": function($event) {
          _vm.setOption(index)
        }
      }
    }, [_c('h1', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('p', {
      staticClass: "hide-sm"
    }, [_vm._v(_vm._s(option))])])])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-full box-overflow"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "row scroll-outer"
  }, [_c('div', [_c('div', {
    staticClass: "row padding-top-96"
  }, [_c('div', {
    staticClass: "span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('h1', {
    staticClass: "upcase"
  }, [_vm._v("Post Survey")]), _vm._v(" "), _c('p', [_vm._v("To help us better serve you and your students please tell us how useful/relevant this program is to you.")]), _vm._v(" "), _c('p', [_vm._v("Rate your level of agreement with the following statements on a scale of 1-5. 1 being “Strongly Disagree” and 5 being “Strongly Agree.” This training:")]), _vm._v(" "), (_vm.postSurveyError) ? _c('p', {
    staticClass: "color-red subheader"
  }, [_vm._v("Please fill out all required fields.")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.captions), function(caption, index) {
    return _c('response', {
      key: index,
      attrs: {
        "ind": (index + 1),
        "caption": caption
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row padding-bottom-96"
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Mentors",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M46.0237305,42.7370199 C46.0237305,42.9280599 40.1962891,45.0346883 40.1962891,55 C26.6022149,55 7.17912475,55 5,55 C5,43.8366699 9.00938495,34.2923521 18.5995594,30.4365191 C17.5912109,29.284668 14.6150391,25.7830811 14.6150391,20.0223796 C14.6150391,13.3143916 19.977644,5 29,5 C37.3938034,5 43.3365234,12.3539225 43.3365234,20.0223796 C43.3365234,26.9734701 39.4415044,30 39.4415044,30.4549123 C41.9315032,31.4624337 44.0442842,32.8543004 45.8074087,34.5589203 C43.4873047,38.6837769 46.0237305,42.461141 46.0237305,42.7370199 Z M65,55 C62.7389391,55 43.3321797,55 41.8,55 C41.8,49.6043905 43.7378694,44.9913035 48.3731204,43.1276509 C47.885752,42.5709229 46.4472689,40.8784892 46.4472689,38.0941501 C46.4472689,34.8519559 49.0391946,30.8333333 53.4,30.8333333 C57.457005,30.8333333 60.3293197,34.3877292 60.3293197,38.0941501 C60.3293197,41.4538439 58.4467271,42.9166667 58.4467271,43.136541 C63.0667836,45.0059416 65,49.6129499 65,55 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "36px",
      "height": "36px",
      "viewBox": "0 0 36 36",
      "version": "1.1"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "ignorehover",
    attrs: {
      "id": "Plus-Accent",
      "fill": "#1E7BBB"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Rectangle-4",
      "points": "17.4857143 0 18.5142857 0 18.5142857 17.4857143 36 17.4857143 36 18.5142857 18.5142857 18.5142857 18.5142857 36 17.4857143 36 17.4857143 18.5142857 0 18.5142857 0 17.4857143 17.4857143 17.4857143"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Mastery",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.2790698,30.4716981 L35,36.9622642 L53.7209302,30.4716981 L53.7209302,47.509434 L35,54 L16.2790698,47.509434 L16.2790698,30.4716981 Z M34.9710399,10.9802545 L69.9341817,23.2264151 L35.0105309,35.3593681 L9.80455984,26.5398771 L9.8293111,41.8196577 L7.39139974,41.8157086 L7.36525374,25.6749118 L0.0473892058,23.1132075 L34.9710399,10.9802545 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Celebrate",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M43.2790698,39.4412331 C43.5312292,38.2350308 43.7327796,37.3739597 43.8837209,36.8580198 C40.617757,36.3330863 37.7682351,34.4224427 35.804946,31.7837846 C39.0932617,28.2905273 41.3909912,24.9151611 42.0333252,21.2908936 C42.6756592,17.666626 42.4430846,11.664917 41.0167911,8.84170619 C42.4430846,8.30235848 44.0951795,8 46,8 C55.9432345,8 59,16.2389029 59,23.4186047 C59,29.8723938 54.2825949,35.8324226 48.1162791,36.8493729 C48.2813181,37.3738822 48.4828685,38.2378356 48.7209302,39.4412331 L46.9078625,39.4412331 L46.9078625,60 L45.0926542,60 L45.0926542,39.4412331 L43.2790698,39.4412331 Z M22.8604651,36.2783459 C23.1514183,34.886574 23.3839764,33.8930304 23.5581395,33.2977151 C16.4160928,32.1497847 11,25.2587449 11,17.7906977 C11,9.50642643 14.5270372,0 26,0 C37.4729628,0 41,9.50642643 41,17.7906977 C41,25.2373775 35.5568403,32.1143337 28.4418605,33.287738 C28.6322902,33.892941 28.8648483,34.8898103 29.1395349,36.2783459 L27.0475336,36.2783459 L27.0475336,60 L24.9530625,60 L24.9530625,36.2783459 L22.8604651,36.2783459 Z M23,3 C18.0032349,6.01678467 15.2982178,11.1021118 14,16 C12.9963379,10.0070801 18.504529,3 23,3 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-container",
    class: _vm.containerClass,
    on: {
      "click": _vm.hideLanding
    }
  }, [_c('h1', {
    staticClass: "color-blue upcase text-center content-translate",
    class: _vm.subHeaderInactive
  }, [_vm._v("Welcome To")]), _vm._v(" "), _c('div', {
    staticClass: "landing-header upcase text-center content-translate",
    class: _vm.headerInactive
  }, [_vm._v("Changing Minds")])])
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Role-Models",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M25.8078182,44.7023878 C28.5551504,44.7023878 30.7823032,42.475235 30.7823032,39.7279029 C30.7823032,36.9805707 28.5551504,34.753418 25.8078182,34.753418 C23.0604861,34.753418 20.8333333,36.9805707 20.8333333,39.7279029 C20.8333333,42.475235 23.0604861,44.7023878 25.8078182,44.7023878 Z M21.8282303,44.2049393 L21.8282303,51.6666667 L25.8078182,49.6768727 L29.7874062,51.6666667 L29.7874062,44.2049393 C28.71454,45.1998363 27.3880107,45.6972848 25.8078182,45.6972848 C24.2276258,45.6972848 22.9010965,45.1998363 21.8282303,44.2049393 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill green"
  }, [_c('polygon', {
    attrs: {
      "points": "5 29.7421167 16.4672451 17.6162426 29.2382412 31.1896762 53.9432575 5 65 16.7345845 28.8929948 55"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header-block"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-16-sm span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('p', {
    staticClass: "large"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-background",
    class: _vm.mainBackgroundClass
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-col-landing"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("\n        Helping Children Impacted by Trauma to Heal and Thrive\n      ")]), _vm._v(" "), _c('p', [_vm._v("Exposure to violence in the community or at home can impact students psychologically, socially, academically, and\n        behaviorally. It often results in trauma, diminished health outcomes, low academic achievement, classroom management\n        issues and a hastened dispatch to child welfare or juvenile justice system--particularly for students of color.")]), _vm._v(" "), _c('p', [_vm._v("\n        While the issue of children’s exposure to violence and trauma is not new for schools, there are now even more promising practices\n        that can help our schools do what they do best - educate.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "nav-button-wrapper",
    on: {
      "click": _vm.closeLanding
    }
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": " float-right call-to-action-blue"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "loading-overlay",
    class: _vm.loadingOverlayClass
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-col"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("WELCOME TO THE CHANGING MINDS ONLINE MODULE")]), _vm._v(" "), _c('img', {
    staticClass: "main-image",
    attrs: {
      "src": "https://s3-us-west-2.amazonaws.com/futures-vpv/futures-1.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links-underlay"
  }, [_c('img', {
    staticClass: "group-image",
    attrs: {
      "src": "https://s3-us-west-2.amazonaws.com/futures-vpv/Group.png"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link-left",
    attrs: {
      "href": "http://www.discoveryeducation.com/",
      "target": "blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link-right",
    attrs: {
      "href": "https://changingmindsnow.org/",
      "target": "blank"
    }
  })])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-container",
    class: _vm.customclass,
    on: {
      "click": _vm.click_event
    }
  }, [(_vm.type === 'next') ? _c('div', {
    staticClass: "button-label-next"
  }, [_c('div', {
    staticClass: "utility upcase"
  }, [_vm._t("default")], 2)]) : (_vm.type === 'back' || _vm.type === 'share') ? _c('div', {
    staticClass: "button-label-back"
  }, [_c('div', {
    staticClass: "utility upcase"
  }, [_vm._t("default")], 2)]) : _vm._e(), _vm._v(" "), (_vm.type === 'next') ? _c('div', {
    staticClass: "button-arrow-next"
  }, [_c('arrow', {
    attrs: {
      "type": _vm.type
    }
  })], 1) : (_vm.type === 'back' || _vm.type === 'share') ? _c('div', {
    staticClass: "button-arrow-back"
  }, [_c('arrow', {
    attrs: {
      "type": _vm.type
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'next') ? _c('div', {
    staticClass: "button-background-next"
  }, [_c('svg', {
    staticClass: "button-background-svg",
    attrs: {
      "viewBox": "0 0 221 48"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', [_c('path', {
    staticClass: "button-background-path",
    attrs: {
      "stroke-width": "1",
      "d": "M0.5,0.5 L0.5,29.3873894 L19.3036863,47.5 L220.5,47.5 L220.5,0.5 L0.5,0.5 Z"
    }
  })])])])]) : _c('div', {
    staticClass: "button-background-back"
  }, [_c('svg', {
    staticClass: "button-background-svg",
    attrs: {
      "viewBox": "0 0 220 48"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Button",
      "transform": "translate(110.000000, 24.000000) scale(-1, 1) translate(-110.000000, -24.000000) "
    }
  }, [_c('path', {
    staticClass: "button-background-path",
    attrs: {
      "stroke-width": "1",
      "d": "M0.5,0.5 L0.5,29.3873894 L19.3036863,47.5 L219.5,47.5 L219.5,0.5 L0.5,0.5 Z"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Neighborhood-Cohesion",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.5,10.5882353 L15.75,10.5931751 L15.75,12.3529412 L12.25,12.3529412 L12.25,15.8823529 L10.5,15.8823529 L10.5,10.5882353 Z M59.5,10.5882353 L59.5,15.8823529 L57.75,15.8823529 L57.75,12.3529412 L54.25,12.3529412 L54.25,10.5882353 L59.5,10.5882353 Z M19.25,10.5882353 L21,10.5882353 L21,12.3529412 L19.25,12.3529412 L19.25,10.5882353 Z M10.5,19.4117647 L12.25,19.4117647 L12.25,24.7058824 L10.5,24.7058824 L10.5,19.4117647 Z M10.5,28.2352941 L12.25,28.2352941 L12.25,33.346856 L10.5,33.346856 L10.5,28.2352941 Z M59.5,28.2352941 L59.5,33.5294118 L57.75,33.5294118 L57.75,28.2352941 L59.5,28.2352941 Z M57.75,19.4117647 L59.5,19.4117647 L59.5,24.7058824 L57.75,24.7058824 L57.75,19.4117647 Z M36.75,58.2352941 L42,58.2352941 L42,60 L36.75,60 L36.75,58.2352941 Z M28,58.2352941 L33.25,58.2352941 L33.25,60 L28,60 L28,58.2352941 Z M49,10.5882353 L50.75,10.5882353 L50.75,12.3529412 L49,12.3529412 L49,10.5882353 Z M12.25,35.2941176 L24.5,44.3529412 L24.5,60 L14.7,60 L14.7,51.7647059 L9.8,51.7647059 L9.8,60 L0,60 L0,44.3529412 L12.25,35.2941176 Z M57.75,35.2941176 L70,44.3529412 L70,60 L60.2,60 L60.2,51.7647059 L55.3,51.7647059 L55.3,60 L45.5,60 L45.5,44.3529412 L57.75,35.2941176 Z M35,0 L47.25,9.05882353 L47.25,24.7058824 L37.45,24.7058824 L37.45,16.4705882 L32.55,16.4705882 L32.55,24.7058824 L22.75,24.7058824 L22.75,9.05882353 L35,0 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Back",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,24 L0,0 L6,0 L6,2 L2.08571429,2 L2.08571429,22 L6,22 L6,24 L0,24 Z M23,18 L13,13 L13,11 L23,6 L23,8 L15,12.0218182 L23,16 L23,18 Z M30,24 L36,24 L36,0 L30,0 L30,2 L34,2 L34,22 L30,22 L30,24 Z",
      "id": "[+]"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.videoFile) ? _c('video', {
    staticClass: "video-component",
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoFile,
      "type": "video/mp4"
    }
  })]) : _c('iframe', {
    staticClass: "video-component",
    attrs: {
      "type": "text/html",
      "src": _vm.video_source,
      "allowFullScreen": ""
    }
  })
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-container",
    class: _vm.notification_class,
    on: {
      "click": _vm.make_inactive
    }
  }, [_c('popup-notification', {
    attrs: {
      "type": "correct",
      "title": _vm.computedTitle
    }
  }, [_vm._v(_vm._s(_vm.captionState.caption))])], 1)
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gutter-horizontal"
  }, [_c('h1', [_vm._v("Organisms")]), _vm._v(" "), _c('div', {
    staticClass: "gutter-vertical"
  }, [_c('h2', [_vm._v("Slide with overflow image")]), _vm._v(" "), _c('overflow-image-slide', {
    attrs: {
      "image": _vm.example_image
    }
  }, [_c('h2', {
    staticClass: "upcase"
  }, [_vm._v("why should I care?")]), _vm._v(" "), _c('p', [_vm._v("Too often, childhood trauma is misdiagnosed and misunderstood. On the outside, its victims look just like regular kids. But on the inside, these kids have been affected emotionally, mentally, and even physically. So much so that their brain development can actually be affected and changed.")]), _vm._v(" "), _c('p', [_vm._v("As with an iceberg,  there’s much more below the surface than above it. Issues that present themselves in a classroom such as absenteeism, poor grades or aggression often are symptoms of the very broad-based, complex issue of trauma.")]), _vm._v(" "), _c('p', [_vm._v("The good news is, we can help kids heal.")])]), _vm._v(" "), _c('div', {
    staticClass: "style-guide-spacer"
  }), _vm._v(" "), _c('h2', [_vm._v("Full span slide")]), _vm._v(" "), _c('full-span-slide', [_c('h1', {
    staticClass: "upcase"
  }, [_vm._v("HELPING children IMPACTED BY trauma TO HEAL AND THRIVE")]), _vm._v(" "), _c('p', [_vm._v("Exposure to violence in the community or at home can impact students  psychologically, socially, academically, and behaviorally. It often results in trauma, diminished health outcomes, low academic achievement, classroom management issues and a hastened dispatch to child welfare or juvenile justice system--particularly for students of color.")]), _vm._v(" "), _c('p', [_vm._v("While the issue of children’s exposure to violence and trauma is not new for schools, there are now even more promising practices that can help our schools do what they do best - educate.")])]), _vm._v(" "), _c('div', {
    staticClass: "style-guide-spacer"
  }), _vm._v(" "), _c('full-span-slide', [_c('p', {
    staticClass: "large"
  }, [_vm._v("Which of these “symptoms” may be an indication of underlying trauma in a child?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('radio-span', [_vm._v("not bold")]), _vm._v(" "), _c('radio-span', {
    attrs: {
      "strong": ""
    }
  }, [_vm._v("is bold")]), _vm._v(" "), _c('radio-span', [_vm._v("etc")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "style-guide-spacer"
  }), _vm._v(" "), _c('h2', [_vm._v("Share Cards")]), _vm._v(" "), _c('header-block', [_vm._v("Did you know?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('share-card', {
    attrs: {
      "bump": "bump-up"
    }
  }, [_c('p', [_c('strong', [_vm._v("Approximately 30% of children")]), _vm._v(" report moderate or frequent involvement in bullying in some capacity.viii Children involved in bullying in any capacity report higher rates of victimization in the home and community than their peers.")])]), _vm._v(" "), _c('share-card', {
    attrs: {
      "bump": "bump-down"
    }
  }, [_c('p', [_c('strong', [_vm._v("Youth ages 10 to 17")]), _vm._v(" who had engaged in delinquent behavior in the past year reported higher rates of exposure to violence than their peers who reported little or no delinquent behavior. Youth who have been exposed to violence are at a higher risk to engage in criminal behavior later in life.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "style-guide-spacer"
  }), _vm._v(" "), _c('h2', [_vm._v("Progress selector slide")]), _vm._v(" "), _c('header-block', [_vm._v("Protective Factors that Promote Resiliency: Individual")]), _vm._v(" "), _c('div', {
    staticClass: "row align-center"
  }, [_c('div', {
    staticClass: "span-9-lg offset-1-lg span-8-md overflow-hidden"
  }, [_c('progress-selector', [_vm._v("one")]), _vm._v(" "), _c('progress-selector', [_vm._v("two")]), _vm._v(" "), _c('progress-selector', [_vm._v("three")]), _vm._v(" "), _c('progress-selector', [_vm._v("four")]), _vm._v(" "), _c('progress-selector', [_vm._v("five")]), _vm._v(" "), _c('progress-selector', [_vm._v("six")]), _vm._v(" "), _c('progress-selector', [_vm._v("seven")])], 1), _vm._v(" "), _c('rollover-card', {
    attrs: {
      "spanclass": "span-4-lg offset-1-lg span-7-md offset-1-md span-16-sm span-16-xs",
      "ratioclass": "ratio-3-4"
    }
  }, [_c('h3', [_vm._v("content here")])])], 1)], 1), _vm._v(" "), _c('navbar')], 1)
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Expression",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35,53.5714286 C22.3025949,53.5714286 5,46.4285714 5,29.2857143 C5,15.8731025 18.4314575,5 35,5 C51.5685425,5 65,15.8730846 65,29.2857143 C65,35.9299463 61.7691465,42.0437407 56.4285714,46.4285714 C56.4285714,50.7142857 59.4086565,53.5714286 60.7142857,55 C57.9071917,55 50.8213588,52.1690151 49.2857143,50.7109895 C45.0203052,52.5481664 40.1701105,53.5714286 35,53.5714286 Z M33.0982143,38.7745098 C33.8592595,38.7745098 36.9685832,38.7745098 37.7589286,38.7745098 C37.7589286,38.0542172 37.7589286,35.7943568 38.5357143,34.9754902 C40.0832826,33.3440852 41.6428571,31.9037493 41.6428571,29.6568627 C41.6428571,26.2998378 38.8606267,23.5784314 35.4285714,23.5784314 C31.9965162,23.5784314 29.2142857,26.2998378 29.2142857,29.6568627 C29.2142857,31.91209 30.780035,33.318002 32.3214286,34.9754902 C33.0982143,35.8107818 33.0982143,38.0401192 33.0982143,38.7745098 Z M33.0982143,40.2941176 C33.0982143,42.3202614 33.3571429,43.3333333 33.875,43.3333333 C34.6517857,43.3333333 36.2205762,43.3333333 36.981005,43.3333333 C37.4879575,43.3333333 37.7472654,42.3202614 37.7589286,40.2941176 L33.0982143,40.2941176 Z M23,29.6568627 L23,31.1764706 L26.8839286,31.1764706 L26.8839286,29.6568627 L23,29.6568627 Z M34.6517857,17.5 L34.6517857,21.2990196 L36.2053571,21.2990196 L36.2053571,17.5 L34.6517857,17.5 Z M45.2298452,21.5760583 L41.9397977,23.4755682 L42.7165834,24.8210005 L46.0066309,22.9214907 L45.2298452,21.5760583 Z M25.6272977,21.5760583 L24.850512,22.9214907 L28.1405595,24.8210005 L28.9173452,23.4755682 L25.6272977,21.5760583 Z M43.9732143,29.6568627 L43.9732143,31.1764706 L47.8571429,31.1764706 L47.8571429,29.6568627 L43.9732143,29.6568627 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Sessions/Auth Sandbox")]), _vm._v(" "), _c('div', {
    on: {
      "keydown": _vm.enter_save_update
    }
  }, [_c('h3', [_vm._v("Register new user or update information")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    attrs: {
      "placeholder": "school"
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm_password),
      expression: "confirm_password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "confirm password"
    },
    domProps: {
      "value": (_vm.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm_password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.save_update
    }
  }, [_vm._v("submit")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.status))])]), _vm._v(" "), (!_vm.authorized) ? _c('div', {
    on: {
      "keydown": _vm.enter_login
    }
  }, [_c('h3', [_vm._v("Log in to view pages")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_email),
      expression: "login_email"
    }],
    attrs: {
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.login_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login_password),
      expression: "login_password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.login_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login_password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("log in")]), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.login_status))])]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('div', {
    staticClass: "page-content"
  }, [_c('h2', [_vm._v("Logged in as " + _vm._s(_vm.page_content.name))]), _vm._v(" "), _c('p', [_vm._v("Current Page: " + _vm._s(_vm.page_content.current_page))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.prev_page
    }
  }, [_vm._v("Go to previous page")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.next_page
    }
  }, [_vm._v("Go to next page")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Risk",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M37.5589228,6.47068661 L64.4527606,50.4345032 C65.3173606,51.8478796 64.8724894,53.6945444 63.459113,54.5591444 C62.9878288,54.8474415 62.4460871,55 61.8936162,55 L8.10594075,55 L8.10594075,55 C6.4490865,55 5.10594075,53.6568542 5.10594075,52 C5.10594075,51.4475292 5.25849929,50.9057874 5.5467964,50.4345032 L32.4406341,6.47068661 L32.4406341,6.47068661 C33.3052341,5.05731021 35.1518989,4.61243903 36.5652753,5.47703903 C36.9704865,5.72491755 37.3110443,6.06547535 37.5589228,6.47068661 L37.5589228,6.47068661 Z M33.9157,39.1018676 L37.0507101,39.1018676 L38.8873826,26.385078 L38.8873826,23.5919847 L32.0473606,23.5919847 L32.0473606,26.385078 L33.9157,39.1018676 Z M32.3640283,46.5939296 L38.6023817,46.5939296 L38.6023817,41.007743 L32.3640283,41.007743 L32.3640283,46.5939296 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-next",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,24 L0,0 L6,0 L6,2 L2.08571429,2 L2.08571429,22 L6,22 L6,24 L0,24 Z M13,18 L13,16 L21,12.0218182 L13,8 L13,6 L23,11 L23,13 L13,18 Z M30,24 L36,24 L36,0 L30,0 L30,2 L34,2 L34,22 L30,22 L30,24 Z"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.align === 'left') ? _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "contentCard",
    staticClass: "span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card show-md"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer center-flex"
  }, [_c('div', {
    staticClass: "slide-content relative ind-1 content-translate",
    class: _vm.contentActiveClass
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span-background', {
    attrs: {
      "full": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "span-8-lg relative ind-2 content-translate",
    class: _vm.mediaActiveClass
  }, [(_vm.image) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image",
    style: (_vm.ratio_styles)
  }, [_c('image-component', {
    attrs: {
      "image": _vm.image
    }
  })], 1) : (_vm.video || _vm.videoFile) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image",
    style: (_vm.ratio_styles)
  }, [_c('video-component', {
    attrs: {
      "video": _vm.video,
      "videoFile": _vm.videoFile
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "contentCard",
    staticClass: "span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card hide-md"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer center-flex"
  }, [_c('div', {
    staticClass: "slide-content relative ind-1 content-translate",
    class: _vm.contentActiveClass
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span-background', {
    attrs: {
      "full": "true"
    }
  })], 1)]) : _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "contentCard",
    staticClass: "span-8-lg bg-white relative ind-1 border-left-right-blue overflow-hidden content-card"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer center-flex"
  }, [_c('div', {
    staticClass: "slide-content relative ind-1 content-translate",
    class: _vm.contentActiveClass
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span-background', {
    attrs: {
      "full": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "span-8-lg relative ind-2 content-translate",
    class: _vm.mediaActiveClass
  }, [(_vm.image) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image overflow-left",
    style: (_vm.ratio_styles)
  }, [_c('image-component', {
    attrs: {
      "image": _vm.image
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.video || _vm.videoFile) ? _c('div', {
    ref: "overflowCard",
    staticClass: "overflow-image overflow-left",
    style: (_vm.ratio_styles)
  }, [_c('video-component', {
    attrs: {
      "video": _vm.video,
      "videoFile": _vm.videoFile
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Stability",
      "fill": "#050C14"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "35 5 10 23.3333333 10 55 30 55 30 38.3333333 40 38.3333333 40 55 60 55 60 23.3333333"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative",
    class: _vm.spanclass
  }, [_c('div', {
    staticClass: "border-bg-rollover center-flex",
    class: _vm.ratioclass
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" here is an h1 ")]), _vm._v(" "), _c('h2', [_vm._v(" here is an h2 ")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v("here is a large paragraph")]), _vm._v(" "), _c('p', [_vm._v("here is a regular paragraph")])])
}]}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "readButton",
    on: {
      "click": _vm.readSlide
    }
  }, [_c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "listenIcon",
    class: _vm.speechClass
  }, [_c('path', {
    attrs: {
      "d": "M55.3315655,60 C50.4262753,60 8.32400865,60 5,60 C5,48.8366699 9.20413794,39.2923521 19.2601482,35.4365191 C18.20282,34.284668 15.0820827,30.7830811 15.0820827,25.0223796 C15.0820827,18.3143916 20.7051722,10 30.1657827,10 C38.9673091,10 45.1986925,17.3539225 45.1986925,25.0223796 C45.1986925,31.9734701 41.1144757,35 41.1144757,35.4549123 C51.1375219,39.3226378 55.3315655,48.8543791 55.3315655,60 Z M56.5135468,0 C57.1358101,0.703613281 58.3803367,2.19213867 59.2822744,2.99804688 C53.1274711,9.984375 53.1134628,19.939209 59.3311806,26.5075684 C58.5597412,27.3359375 57.0635568,28.7272949 56.5626987,29.4289551 C48.1567374,22.3168945 48.2803545,7.24584961 56.5135468,0 Z M62.2035015,5 C62.7930788,5.62475586 64.4176886,7.10908194 65,7.62939453 C61.5874563,11.1784668 61.5874563,18.2973633 65,20.9943848 C64.5019413,21.5291986 62.5268669,23.1898146 62.2035015,23.6428223 C56.8599506,19.1608887 57.2792165,9.5625 62.2035015,5 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "span-16-lg relative border-left-right-blue",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "relative ind-1 full-span-outer overflow-hidden"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer"
  }, [_c('div', {
    staticClass: "full-span-inner content-translate",
    class: _vm.contentClass
  }, [_vm._t("default")], 2)])]), _vm._v(" "), (!_vm.nobg) ? _c('span-background', {
    attrs: {
      "full": "true"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hatch-container",
    class: _vm.customClasses
  }, [_c('div', {
    staticClass: "svg-background-left"
  }, [_c('hatch-bg')], 1), _vm._v(" "), _c('div', {
    staticClass: "svg-background-right"
  }, [_c('hatch-bg')], 1)])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Classroom-Support",
      "fill": "#050C14"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M52,55 C52,47.4209778 49.166838,40.9393937 42.3960656,38.3093404 C42.3960656,38 45.1550374,35.9419596 45.1550374,31.2152181 C45.1550374,26.0006673 40.9456107,21 35,21 C28.6091645,21 24.8106527,26.6537863 24.8106527,31.2152181 C24.8106527,35.1324951 26.9187744,37.5135742 27.6330212,38.296833 C20.839981,40.9187994 18,47.4089355 18,55 C20.2454357,55 48.6863763,55 52,55 Z",
      "id": "Oval-2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "x": "34",
      "y": "4",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(50.000000, 13.000000) rotate(-315.000000) translate(-50.000000, -13.000000) ",
      "x": "49",
      "y": "8",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(20.000000, 13.000000) rotate(-45.000000) translate(-20.000000, -13.000000) ",
      "x": "19",
      "y": "8",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(12.000000, 23.000000) rotate(-75.000000) translate(-12.000000, -23.000000) ",
      "x": "11",
      "y": "18",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle",
      "transform": "translate(58.000000, 23.000000) scale(-1, 1) rotate(-75.000000) translate(-58.000000, -23.000000) ",
      "x": "57",
      "y": "18",
      "width": "2",
      "height": "10",
      "rx": "1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.9159265,44.1633367 C18.3540958,43.7976614 17.739377,43.480837 17.069586,43.2183579 C17.069586,43 19,41.5472656 19,38.2107422 C19,3s4.5298828 16.054723,31 11.8946623,31 C7.42308404,31 4.76531844,34.990908 4.76531844,38.2107422 C4.76531844,40.9758789 6.24034175,42.6566406 6.74009027,43.2095292 C1.987095,45.060329 0,49.6416016 0,55 C1.04319508,55 9.44323665,55 16.1356689,55 C16.1356689,51.6461182 16.716342,46.821167 18.9159265,44.1633367 Z",
      "id": "Oval-2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M51.0840735,44.1633367 C51.6459042,43.7976614 52.260623,43.480837 52.930414,43.2183579 C52.930414,43 51,41.5472656 51,38.2107422 C51,34.5298828 53.945277,31 58.1053377,31 C62.576916,31 65.2346816,34.990908 65.2346816,38.2107422 C65.2346816,40.9758789 63.7596582,42.6566406 63.2599097,43.2095292 C68.012905,45.060329 70,49.6416016 70,55 L53.8643311,55 C53.8643311,51.6461182 53.283658,46.821167 51.0840735,44.1633367 Z",
      "id": "Oval-2"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "row scroll-outer scroll-padding-bottom"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.markedCards), function(card, index) {
    return _c('flip-card', {
      key: index,
      attrs: {
        "ind": index,
        "active": _vm.active,
        "icon": card.icon,
        "title": card.title,
        "cardSize": _vm.card_size
      },
      on: {
        "flip": _vm.change_flip_count
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(card.paragraph)
      }
    })])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "utility bump-up-24 bump-down-12-mobile"
  }, [_c('strong', [_vm._v("Click")]), _vm._v(" through each tile to flip before proceeding to "), _c('strong', [_vm._v("'Next'")]), _vm._v(" button. ")])
}]}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Access-to-Services",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.45945946,9.67741935 L15.1327102,9.68904164 L15.1327102,11.6129032 L11.3513514,11.6129032 L11.3513514,15.483871 L9.45945946,15.483871 L9.45945946,9.67741935 Z M58.6486486,9.67741935 L58.6486486,15.4719396 L56.7567568,15.4797954 L56.7567568,11.620759 L52.972973,11.6129032 L52.972973,9.67741935 L58.6486486,9.67741935 Z M18.9189189,9.67741935 L20.8108108,9.67741935 L20.8108108,11.6129032 L18.9189189,11.6129032 L18.9189189,9.67741935 Z M9.45945946,19.3548387 L11.3513514,19.3548387 L11.3513514,25.1612903 L9.45945946,25.1612903 L9.45945946,19.3548387 Z M9.45945946,29.0322581 L11.3513514,29.0322581 L11.3513514,34.8387097 L9.45945946,34.8387097 L9.45945946,29.0322581 Z M58.6486486,29.0322581 L58.6486486,34.8387097 L56.7567568,34.8387097 L56.7567568,29.0322581 L58.6486486,29.0322581 Z M56.7567568,19.3548387 L58.6486486,19.3548387 L58.6486486,25.1612903 L56.7567568,25.1612903 L56.7567568,19.3548387 Z M37.8378378,58.0645161 L43.5135135,58.0645161 L43.5135135,60 L37.8378378,60 L37.8378378,58.0645161 Z M28.3783784,58.0645161 L34.0540541,58.0645161 L34.0540541,60 L28.3783784,60 L28.3783784,58.0645161 Z M18.9189189,58.0645161 L24.5945946,58.0645161 L24.5945946,60 L18.9189189,60 L18.9189189,58.0645161 Z M47.2972973,9.67741935 L49.1891892,9.67741935 L49.1891892,11.6129032 L47.2972973,11.6129032 L47.2972973,9.67741935 Z M52.972973,44.9032258 L52.972973,40.2580645 L58.6486486,36.7741935 L64.3243243,40.2580645 L64.3243243,44.9032258 L70,44.9032258 L70,60 L60.932538,60 L60.9319046,51.8876953 L56.3786159,51.8876953 L56.3786159,60 L47.2972973,60 L47.2972973,44.9032258 L52.972973,44.9032258 Z M58.6494627,46.0645161 C59.9032984,46.0645161 60.919733,45.0246614 60.919733,43.7419355 C60.919733,42.4592096 59.9032984,41.4193548 58.6494627,41.4193548 C57.3956271,41.4193548 56.3791924,42.4592096 56.3791924,43.7419355 C56.3791924,45.0246614 57.3956271,46.0645161 58.6494627,46.0645161 Z M34.0540541,0 L45.4054054,8.51612903 L45.4054054,23.2258065 L36.3243243,23.2258065 L36.3243243,15.483871 L31.7837838,15.483871 L31.7837838,23.2258065 L22.7027027,23.2258065 L22.7027027,8.51612903 L34.0540541,0 Z M5.67567568,38.7096774 L15.1351351,38.7096774 L15.1351351,44.516129 L20.8108108,44.516129 L20.8108108,54.1935484 L15.1351351,54.1935484 L15.1351351,60 L5.67567568,60 L5.67567568,54.1935484 L0,54.1935484 L0,44.516129 L5.67567568,44.516129 L5.67567568,38.7096774 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-component",
    style: (_vm.background_image)
  }, [_c('div', {
    staticClass: "image-component-overlay",
    class: _vm.overlay_class
  })])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crosshair-container ind-2"
  }, [_c('crosshair-svg'), _vm._v(" "), _c('crosshair-svg'), _vm._v(" "), _c('crosshair-svg'), _vm._v(" "), _c('crosshair-svg')], 1)
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "flipCard",
    staticClass: "relative span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs share-flip-outer no-border content-translate",
    class: [_vm.cardSizeClass, _vm.contentActiveClass],
    style: (_vm.ratio_styles)
  }, [_c('div', {
    staticClass: "flip-container"
  }, [_c('div', {
    staticClass: "flipper crosshair-rollover-trigger",
    on: {
      "click": _vm.flip
    }
  }, [_c('div', {
    staticClass: "front ind-2 border-blue-hover center-flex",
    class: _vm.flipped,
    attrs: {
      "front-card": ""
    }
  }, [_c('div', {
    staticClass: "front-inner"
  }, [(_vm.icon) ? _c('div', {
    staticClass: "svg-icon-background big-svg"
  }, [_c(_vm.icon, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subheader "
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "back border-blue-hover",
    class: _vm.flipped
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer maintain-outer"
  }, [_c('div', {
    staticClass: "back-inner"
  }, [_c('div', {
    staticClass: "subheader "
  }, [(_vm.icon) ? _c('div', {
    staticClass: "svg-icon-background svg-icon-background-small"
  }, [_c(_vm.icon, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', [_vm._t("default")], 2)])])])]), _vm._v(" "), (_vm.cardSize < 4) ? _c('crosshair-background') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "12px",
      "height": "11px",
      "viewBox": "0 0 12 11"
    }
  }, [_c('g', {
    attrs: {
      "id": "FINAL",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "pdf-fill-group",
    attrs: {
      "id": "Half-Caring-Adult",
      "transform": "translate(-649.000000, -769.000000)",
      "fill": "#51575D"
    }
  }, [_c('g', {
    attrs: {
      "id": "Download-PDF",
      "transform": "translate(649.000000, 762.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "download",
      "transform": "translate(0.000000, 7.000000)"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "downlaod",
      "points": "12 5.07692308 8.57142857 5.07692308 8.57142857 0 3.42857143 0 3.42857143 5.07692308 0 5.07692308 6 11"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Home",
      "fill": "#050C14"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "35 5 10 23.3333333 10 55 30 55 30 38.3333333 40 38.3333333 40 55 60 55 60 23.3333333"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Inspire",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M30.15625,50.2492522 C30.15625,48.5146611 30.15625,43.2490856 28.375,41.2761715 C24.8404251,37.3612731 21.25,34.0405845 21.25,28.7138584 C21.25,20.7847454 27.6299423,14.3569292 35.5,14.3569292 C43.3700577,14.3569292 49.75,20.7847454 49.75,28.7138584 C49.75,34.020884 46.1737343,37.4228803 42.625,41.2761715 C40.84375,43.2102906 40.84375,48.5479596 40.84375,50.2492522 C39.0314064,50.2492522 31.9014053,50.2492522 30.15625,50.2492522 Z M30.15625,52.8215354 L40.84375,52.8215354 C40.8170052,57.6071785 40.2223854,60 39.0598907,60 C37.3161488,60 33.71875,60 31.9375,60 C30.75,60 30.15625,57.6071785 30.15625,52.8215354 Z M7,28.7138584 L15.90625,28.7138584 L15.90625,32.3030907 L7,32.3030907 L7,28.7138584 Z M33.71875,0 L37.28125,0 L37.28125,8.97308076 L33.71875,8.97308076 L33.71875,0 Z M58.0885829,9.6737432 L59.8698329,12.7589587 L52.0989171,17.2454991 L50.3176671,14.1602836 L58.0885829,9.6737432 Z M12.9114171,9.6737432 L20.6823329,14.1602836 L18.9010829,17.2454991 L11.1301671,12.7589587 L12.9114171,9.6737432 Z M55.09375,28.7138584 L64,28.7138584 L64,32.3030907 L55.09375,32.3030907 L55.09375,28.7138584 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Learning-Success",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.5,5 L49.5,5 L49.5,5 C50.8807119,5 52,6.11928813 52,7.5 L52,8 C52,9.1045695 51.1045695,10 50,10 L50,14 L51,14 C53.7614237,14 56,16.2385763 56,19 L56,27 C56,29.7614237 53.7614237,32 51,32 L50,32 C50,36.9705627 45.9705627,41 41,41 L38,41 L38,50 L48.5,50 L48.5,50 C49.8807119,50 51,51.1192881 51,52.5 L51,52.5 C51,53.8807119 49.8807119,55 48.5,55 L22.5,55 L22.5,55 C21.1192881,55 20,53.8807119 20,52.5 C20,51.1192881 21.1192881,50 22.5,50 L32,50 L32,41 L29,41 L29,41 C24.0294373,41 20,36.9705627 20,32 L20,32 L19,32 L19,32 C16.2385763,32 14,29.7614237 14,27 L14,19 C14,16.2385763 16.2385763,14 19,14 L20,14 L20,10 C18.8954305,10 18,9.1045695 18,8 L18,7.5 L18,7.5 C18,6.11928813 19.1192881,5 20.5,5 L20.5,5 Z M19,17 L19,17 C17.8954305,17 17,17.8954305 17,19 L17,19 L17,27 C17,28.1045695 17.8954305,29 19,29 L20,29 L20,17 L19,17 Z M50,17 L50,29 L51,29 C52.1045695,29 53,28.1045695 53,27 L53,19 C53,17.8954305 52.1045695,17 51,17 L50,17 Z M35,26.5 L40.2900673,29.2811529 L39.2797543,23.3905765 L43.5595086,19.2188471 L37.6450336,18.3594235 L35,13 L32.3549664,18.3594235 L26.4404914,19.2188471 L30.7202457,23.3905765 L29.7099327,29.2811529 L35,26.5 Z",
      "id": "Combined-Shape"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "55px",
      "height": "55px",
      "viewBox": "0 0 55 55"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Community",
      "transform": "translate(-8.000000, 0.000000)",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.6192787,8.33969726 C33.3158745,8.33969726 31.4485965,6.47279243 31.4485965,4.16984863 C31.4485965,1.86690482 33.3158745,0 35.6192787,0 C37.9226829,0 39.7899609,1.86690482 39.7899609,4.16984863 C39.7899609,6.47279243 37.9226829,8.33969726 35.6192787,8.33969726 Z M24.5829061,2.66918316 C26.0336596,1.88035869 27.8493241,2.41672314 28.6383063,3.86718667 C28.6434785,3.87669535 28.6485991,3.88623205 28.6536678,3.89579633 L34.9894409,15.8510583 C35.1435027,16.1417646 35.5041056,16.2525618 35.7948701,16.0985308 C35.9006053,16.0425181 35.9870217,15.955972 36.0428657,15.8501627 L42.3508768,3.89819883 C43.1202627,2.44042198 44.925971,1.8822462 46.3840393,2.65147833 C46.3950945,2.65731069 46.4061129,2.66321242 46.4170939,2.66918316 C47.8846957,3.46716864 48.4293506,5.30225362 47.6346434,6.77142616 L39.8541585,21.1551831 C38.9894118,22.7538373 37.3178295,23.75 35.5,23.75 C33.6821705,23.75 32.0105882,22.7538373 31.1458415,21.1551831 L23.3653566,6.77142616 C22.5706494,5.30225362 23.1153043,3.46716864 24.5829061,2.66918316 Z M35.6192787,46.6603027 C37.9226829,46.6603027 39.7899609,48.5272076 39.7899609,50.8301514 C39.7899609,53.1330952 37.9226829,55 35.6192787,55 C33.3158745,55 31.4485965,53.1330952 31.4485965,50.8301514 C31.4485965,48.5272076 33.3158745,46.6603027 35.6192787,46.6603027 Z M24.5829061,52.3308168 C23.1153043,51.5328314 22.5706494,49.6977464 23.3653566,48.2285738 L31.1458415,33.8448169 C32.0105882,32.2461627 33.6821705,31.25 35.5,31.25 C37.3178295,31.25 38.9894118,32.2461627 39.8541585,33.8448169 L47.6346434,48.2285738 C48.4293506,49.6977464 47.8846957,51.5328314 46.4170939,52.3308168 C46.4061129,52.3367876 46.3950945,52.3426893 46.3840393,52.3485217 C44.925971,53.1177538 43.1202627,52.559578 42.3508768,51.1018012 L36.0428657,39.1498373 C35.9870217,39.044028 35.9006053,38.9574819 35.7948701,38.9014692 C35.5041056,38.7474382 35.1435027,38.8582354 34.9894409,39.1489417 L28.6536678,51.1042037 C28.6485991,51.113768 28.6434785,51.1233046 28.6383063,51.1328133 C27.8493241,52.5832769 26.0336596,53.1196413 24.5829061,52.3308168 Z M16.3396973,27.6192787 C16.3396973,29.9226829 14.4727924,31.7899609 12.1698486,31.7899609 C9.86690482,31.7899609 8,29.9226829 8,27.6192787 C8,25.3158745 9.86690482,23.4485965 12.1698486,23.4485965 C14.4727924,23.4485965 16.3396973,25.3158745 16.3396973,27.6192787 Z M10.6691832,16.5829061 C11.4671686,15.1153043 13.3022536,14.5706494 14.7714262,15.3653566 L29.1551831,23.1458415 C30.7538373,24.0105882 31.75,25.6821705 31.75,27.5 C31.75,29.3178295 30.7538373,30.9894118 29.1551831,31.8541585 L14.7714262,39.6346434 C13.3022536,40.4293506 11.4671686,39.8846957 10.6691832,38.4170939 C10.6632124,38.4061129 10.6573107,38.3950945 10.6514783,38.3840393 C9.8822462,36.925971 10.440422,35.1202627 11.8981988,34.3508768 L23.8501627,28.0428657 C23.955972,27.9870217 24.0425181,27.9006053 24.0985308,27.7948701 C24.2525618,27.5041056 24.1417646,27.1435027 23.8510583,26.9894409 L11.8957963,20.6536678 C11.886232,20.6485991 11.8766954,20.6434785 11.8671867,20.6383063 C10.4167231,19.8493241 9.88035869,18.0336596 10.6691832,16.5829061 Z M54.6603027,27.6192787 C54.6603027,25.3158745 56.5272076,23.4485965 58.8301514,23.4485965 C61.1330952,23.4485965 63,25.3158745 63,27.6192787 C63,29.9226829 61.1330952,31.7899609 58.8301514,31.7899609 C56.5272076,31.7899609 54.6603027,29.9226829 54.6603027,27.6192787 Z M60.3308168,16.5829061 C61.1196413,18.0336596 60.5832769,19.8493241 59.1328133,20.6383063 C59.1233046,20.6434785 59.113768,20.6485991 59.1042037,20.6536678 L47.1489417,26.9894409 C46.8582354,27.1435027 46.7474382,27.5041056 46.9014692,27.7948701 C46.9574819,27.9006053 47.044028,27.9870217 47.1498373,28.0428657 L59.1018012,34.3508768 C60.559578,35.1202627 61.1177538,36.925971 60.3485217,38.3840393 C60.3426893,38.3950945 60.3367876,38.4061129 60.3308168,38.4170939 C59.5328314,39.8846957 57.6977464,40.4293506 56.2285738,39.6346434 L41.8448169,31.8541585 C40.2461627,30.9894118 39.25,29.3178295 39.25,27.5 C39.25,25.6821705 40.2461627,24.0105882 41.8448169,23.1458415 L56.2285738,15.3653566 C57.6977464,14.5706494 59.5328314,15.1153043 60.3308168,16.5829061 Z",
      "id": "Combined-Shape"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-span",
    class: [_vm.is_full, _vm.is_survey]
  }, [_c('span', [_c('radio', {
    attrs: {
      "correct": _vm.correct,
      "caption": _vm.caption,
      "group": _vm.group,
      "title": _vm.title,
      "groupQuestion": _vm.groupQuestion
    }
  })], 1), _vm._v(" "), (_vm.is_strong) ? _c('p', [_c('strong', [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _c('p', [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-School",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.2857143,22.3602213 L21.2857143,13.3333333 L35.1927179,5 L48.7142857,13.3333333 L48.7142857,22.3182013 L65,22.3182013 L65,55 L41.0359933,55 L41.0343192,37.5360107 L29.0006278,37.5360107 L29.0006278,55 L5,55 L5,22.3602213 L21.2857143,22.3602213 Z M35,26.6666667 C38.3137085,26.6666667 41,24.0549944 41,20.8333333 C41,17.6116723 38.3137085,15 35,15 C31.6862915,15 29,17.6116723 29,20.8333333 C29,24.0549944 31.6862915,26.6666667 35,26.6666667 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Combination",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.8571429,12 L16.9927281,12 L16.9927281,13.7142857 L13.5714286,13.7142857 L13.5714286,17.1494489 L11.8571429,17.1494489 L11.8571429,12 Z M58.1428571,12 L58.1428571,17.1494489 L56.4285714,17.1494489 L56.4285714,13.7142857 L53,13.7142857 L53,12 L58.1428571,12 Z M20.4285714,12 L22.1428571,12 L22.1428571,13.7142857 L20.4285714,13.7142857 L20.4285714,12 Z M11.8571429,20.5714286 L13.5714286,20.5714286 L13.5714286,25.7142857 L11.8571429,25.7142857 L11.8571429,20.5714286 Z M11.8571429,29.1428571 L13.5714286,29.1428571 L13.5714286,34.2857143 L11.8571429,34.2857143 L11.8571429,29.1428571 Z M58.1428571,29.1428571 L58.1428571,34.2857143 L56.4285714,34.2857143 L56.4285714,29.1428571 L58.1428571,29.1428571 Z M56.4285714,20.5714286 L58.1428571,20.5714286 L58.1428571,25.7142857 L56.4285714,25.7142857 L56.4285714,20.5714286 Z M41,56.5714286 L46.1428571,56.5714286 L46.1428571,58.2857143 L41,58.2857143 L41,56.5714286 Z M32.4285714,56.5714286 L37.5714286,56.5714286 L37.5714286,58.2857143 L32.4285714,58.2857143 L32.4285714,56.5714286 Z M23.8571429,56.5714286 L29,56.5714286 L29,58.2857143 L23.8571429,58.2857143 L23.8571429,56.5714286 Z M47.8571429,12 L49.5714286,12 L49.5714286,13.7142857 L47.8571429,13.7142857 L47.8571429,12 Z M35,25.7142857 C27.5714286,23.7040803 23.8571429,17.3782842 23.8571429,6.73689751 C24.8292411,6.73689751 32.6799729,2.89288093 35,0 C37.1568017,2.89288093 45.1782401,6.73689751 46.1428571,6.73689751 C46.1428571,17.1186557 42.4285714,23.4444518 35,25.7142857 Z M35,23.5714286 C35,9.74637277 35,2.60351562 35,2.14285714 C33.0511772,4.55359125 26.4565625,7.7569384 25.64,7.7569384 C25.64,16.6247607 28.76,21.8962574 35,23.5714286 Z M53.8571429,60 C46.4285714,57.9897946 42.7142857,51.6639985 42.7142857,41.0226118 C43.6863839,41.0226118 51.5371157,37.1785952 53.8571429,34.2857143 C56.0139446,37.1785952 64.035383,41.0226118 65,41.0226118 C65,51.40437 61.2857143,57.7301661 53.8571429,60 Z M16.1428571,60 C8.71428571,57.9897946 5,51.6639985 5,41.0226118 C5.97209821,41.0226118 13.82283,37.1785952 16.1428571,34.2857143 C18.2996588,37.1785952 26.3210972,41.0226118 27.2857143,41.0226118 C27.2857143,51.40437 23.5714286,57.7301661 16.1428571,60 Z M16,48.0489502 C16,40.6372385 16,36.763779 16,36.4285714 C14.0511772,38.8393055 7.59941964,42.0426527 6.78285714,42.0426527 C6.78285714,44.2592839 6.97780008,46.2512105 7.36768597,48.0184325 C9.00610352,48.0184325 13.8880266,48.0184325 16,48.0489502 Z M16,48 L16,58.3729248 C18.3935016,57.4036279 20.3836953,56.0373763 21.9705811,54.2741699 C23.5574668,52.5109635 24.5672731,50.4195736 25,48 L16,48 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-auto box-overflow"
  }, [_c('full-span-slide', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._l((_vm.markedParagraphs), function(paragraph) {
    return _c('p', {
      key: paragraph.index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _vm._v(" "), (_vm.content.text_box) ? _c('div', [_c('textarea', {
    ref: "textarea",
    staticClass: "form-text-area p",
    attrs: {
      "placeholder": _vm.content.text_box
    },
    on: {
      "keyup": _vm.keyCallback
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "transition-1",
    class: _vm.showCaptionClass
  }, [_vm._v("Press "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ENTER")]), _vm._v(" to submit")])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overflow-image-slide', {
    attrs: {
      "image": _vm.content.image,
      "video": _vm.content.video,
      "videoFile": _vm.content.videoFile,
      "align": _vm.content.align,
      "active": _vm.active
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._l((_vm.markedParagraphs), function(paragraph) {
    return _c('p', {
      key: paragraph.index,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isSurvey
  }, [(_vm.loggedIn) ? _c('div', {
    staticClass: "gutter-horizontal",
    class: _vm.fullTemplate.gutter
  }, _vm._l((_vm.pages), function(page, index) {
    return _c('div', {
      key: index,
      staticClass: "slide",
      class: [_vm.slide_active(index).class, _vm.slide_in_queue(index)]
    }, [_c(page.template, {
      tag: "component",
      attrs: {
        "content": page.content,
        "title": page.title,
        "active": _vm.slide_active(index).bool
      }
    }, [_vm._v("\n        " + _vm._s(page.content) + "\n      ")])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('progress-bar', {
    attrs: {
      "complete": _vm.percentComplete,
      "hidden": _vm.fullTemplate.progressHidden
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('page-bar') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('readButton') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('navbar', {
    attrs: {
      "nextCondition": _vm.nextCondition
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('notification', {
    attrs: {
      "state": _vm.notification_state,
      "captionState": _vm.caption_state
    }
  }) : _vm._e(), _vm._v(" "), _c('login'), _vm._v(" "), (_vm.landingFirstComplete) ? _c('landing-screen') : _vm._e(), _vm._v(" "), _c('landing-first', {
    on: {
      "complete": _vm.landingFirstCompleteCb
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Health"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#000000",
      "points": "25 5 45 5 45 20 60 20 60 40 45 40 45 55 25 55 25 40 10 40 10 20 25 20"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "fill": "#050C14",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Listen",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M55.3315655,60 C50.4262753,60 8.32400865,60 5,60 C5,48.8366699 9.20413794,39.2923521 19.2601482,35.4365191 C18.20282,34.284668 15.0820827,30.7830811 15.0820827,25.0223796 C15.0820827,18.3143916 20.7051722,10 30.1657827,10 C38.9673091,10 45.1986925,17.3539225 45.1986925,25.0223796 C45.1986925,31.9734701 41.1144757,35 41.1144757,35.4549123 C51.1375219,39.3226378 55.3315655,48.8543791 55.3315655,60 Z M56.5135468,0 C57.1358101,0.703613281 58.3803367,2.19213867 59.2822744,2.99804688 C53.1274711,9.984375 53.1134628,19.939209 59.3311806,26.5075684 C58.5597412,27.3359375 57.0635568,28.7272949 56.5626987,29.4289551 C48.1567374,22.3168945 48.2803545,7.24584961 56.5135468,0 Z M62.2035015,5 C62.7930788,5.62475586 64.4176886,7.10908194 65,7.62939453 C61.5874563,11.1784668 61.5874563,18.2973633 65,20.9943848 C64.5019413,21.5291986 62.5268669,23.1898146 62.2035015,23.6428223 C56.8599506,19.1608887 57.2792165,9.5625 62.2035015,5 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spacer"
  })
},staticRenderFns: []}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-auto box-overflow"
  }, [_c('full-span-slide', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "utility bump-down-12-mobile"
  }, [_c('strong', [_vm._v("Click")]), _vm._v(" the correct answer before proceeding to the "), _c('strong', [_vm._v("'Next'")]), _vm._v(" button.")]), _vm._v(" "), _c('div', {
    staticClass: "row span-16-lg"
  }, _vm._l((_vm.content.options), function(option) {
    return _c('radio-span', {
      key: option.index,
      attrs: {
        "strong": option.strong,
        "correct": option.correct,
        "caption": option.caption,
        "title": option.title
      }
    })
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bar-container"
  }, [(_vm.currentPage !== 0) ? _c('span', {
    staticClass: "p color-orange"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.allPages) + " ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Temperment",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C58.5441081,55 11.7993164,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M35,50 C40.5555556,46.9590901 43.3333333,43.8522984 43.3333333,40.6796247 C43.3333333,35.9206142 39.6023729,34.1729476 35,37.6900703 C30.3976271,34.1729476 26.6666667,35.9206142 26.6666667,40.6796247 C26.6666667,43.8522984 29.4444444,46.9590901 35,50 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Protective",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35.5,55 C20.5,51.0912672 13,38.7911082 13,18.0995229 C14.9628906,18.0995229 30.8153298,10.6250463 35.5,5 C39.8550803,10.6250463 56.0522156,18.0995229 58,18.0995229 C58,38.286275 50.5,50.5864341 35.5,55 Z M35.5,50.8333333 C35.5,23.9512804 35.5,10.0623915 35.5,9.16666667 C31.564877,13.8542052 18.2488281,20.0829358 16.6,20.0829358 C16.6,37.3259235 22.9,47.576056 35.5,50.8333333 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Collaborate",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.0199332,28.199233 C16.2633815,27.977708 15.5295126,27.719377 14.8214286,27.4265937 C13.8616507,28.301409 9.4330052,30 7.67857143,30 C8.49458967,29.1428571 10.3571429,27.4285714 10.3571429,24.8571429 C7.01928342,22.2262444 5,18.5579678 5,14.5714286 C5,6.52385079 13.3946609,0 23.75,0 C34.1053391,0 42.5,6.52386153 42.5,14.5714286 C42.5,15.8068382 42.3439929,16.9556905 42.0557038,18.0209557 C28.7954102,17.5239258 19.8779297,23.2629395 17.0199332,28.199233 Z M40,58.8571429 C29.4188291,58.8571429 15,53.1428571 15,39.4285714 C15,28.698482 26.1928813,20 40,20 C53.8071187,20 65,28.6984677 65,39.4285714 C65,44.7439571 62.3076221,49.6349926 57.8571429,53.1428571 C57.8571429,56.5714286 60.3405471,58.8571429 61.4285714,60 C59.0893264,60 53.1844657,57.7352121 51.9047619,56.5687916 C48.3502543,58.0385331 44.3084254,58.8571429 40,58.8571429 Z M40,42 C41.1045695,42 42,41.1045695 42,40 C42,38.8954305 41.1045695,38 40,38 C38.8954305,38 38,38.8954305 38,40 C38,41.1045695 38.8954305,42 40,42 Z M49,42 C50.1045695,42 51,41.1045695 51,40 C51,38.8954305 50.1045695,38 49,38 C47.8954305,38 47,38.8954305 47,40 C47,41.1045695 47.8954305,42 49,42 Z M31,42 C32.1045695,42 33,41.1045695 33,40 C33,38.8954305 32.1045695,38 31,38 C29.8954305,38 29,38.8954305 29,40 C29,41.1045695 29.8954305,42 31,42 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Supportive-Relationships",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M45,55 C43.0508096,55 26.3208445,55 25,55 C25,50.534668 26.6705771,46.7169408 30.6664831,45.1746076 C30.2463379,44.7138672 29.0062663,43.3132324 29.0062663,41.0089518 C29.0062663,38.3257566 31.240685,35 35,35 C38.4974181,35 40.9735514,37.941569 40.9735514,41.0089518 C40.9735514,43.789388 39.3506268,45 39.3506268,45.1819649 C43.3334341,46.7290551 45,50.5417516 45,55 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "row scroll-outer scroll-padding-bottom"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs "
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row span-16-lg span-16-md span-16-sm span-16-xs  "
  }, [_c('div', {
    staticClass: "span-9-lg offset-1-lg span-8-md max-height-selector  overflow-hidden"
  }, _vm._l((_vm.content.cards), function(card, index) {
    return _c('progress-selector', {
      key: index,
      ref: index + 1,
      refInFor: true,
      attrs: {
        "index": index,
        "activeindex": _vm.offset_index
      },
      on: {
        "clicked": function($event) {
          _vm.selectorCallback(card, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(card.title) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    ref: "selectorCard",
    staticClass: "span-4-lg offset-1-lg span-6-md offset-1-md span-16-sm span-16-xs bg-white border-blue-hover selector-indicator-card content-translate ",
    class: [_vm.indicatorClass, _vm.indicatorVisibleClass, _vm.contentActiveClass, _vm.hasContentClass],
    style: (_vm.ratio_styles),
    attrs: {
      "container-card": "selector-card"
    },
    on: {
      "click": _vm.toggleIndicator
    }
  }, [_c('div', {
    staticClass: "mobile-only arrow-back-container",
    on: {
      "click": _vm.toggleIndicator
    }
  }, [_c('arrow', {
    attrs: {
      "type": "prev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "overflow-hidden center-flex cover-class crosshair-rollover-trigger",
    class: _vm.hasContentClass
  }, [_c('div', {
    ref: "scrollHookTwo",
    staticClass: "scroll-outer maintain-outer"
  }, [(_vm.card) ? _c('div', {
    staticClass: "card-inner"
  }, [_c(_vm.card.icon, {
    tag: "component",
    staticClass: "big-svg svg-fill-blue"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheader color-blue"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.markedCard.paragraph)
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('crosshair-background')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "utility bump-up-24 bump-down-12-mobile"
  }, [_c('strong', [_vm._v("Click")]), _vm._v(" through each arrow to learn more before proceeding to the "), _c('strong', [_vm._v("'Next'")]), _vm._v(" button.\n      ")])
}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-auto box-overflow"
  }, [_c('full-span-slide', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('div', {
    staticClass: "span-16-lg span-16-mg span-16-sm span-16-xs text-center"
  }, [_c('h1', [_vm._v("Thank You")]), _vm._v(" "), _c('p', [_vm._v("This project is made possible by "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Verizon")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("With support from The Jonathan Logan Family Foundation.")]), _vm._v(" "), _c('p', [_vm._v("Developed by "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Futures Without Violence")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-both-24 sponsor-image-container"
  }, [_c('div', {
    staticClass: "span-4-lg span-4-md ratio-4-3 bg-image-span bg-fwv"
  }), _vm._v(" "), _c('div', {
    staticClass: "span-4-lg span-4-md offset-2-lg offset-2-md ratio-4-3 bg-image-span bg-verizon"
  }), _vm._v(" "), _c('div', {
    staticClass: "span-4-lg span-4-md offset-2-lg offset-2-md ratio-4-3 bg-image-span bg-jlff"
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-16-lg span-16-mg span-16-sm span-16-xs text-center"
  }, [_c('p', [_vm._v("Based in part on the curricula "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Changing Minds: A Leadership Institute for Educators and Community Partners")]), _vm._v(" developed under "), _c('br'), _vm._v("the Office of Juvenile Justice and Delinquency Prevention, U.S. Department of Justice, and"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Middle School Matters")]), _vm._v(", a project of the Jonathan Logan Family Foundation.")])]), _vm._v(" "), _c('div', {
    staticClass: "p utility disclaimer text-center"
  }, [_vm._v("Points of view or opinions expressed in this document are those of the authors and do not necessarily represent the official position or policies of OJJDP or the U.S. Department of Justice.")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Culture",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M38.4848485,8.37209302 C34.6069109,8.37209302 32.6838236,17.8296126 32.3239495,21.7263354 C27.8805521,21.9912677 18.969697,24.2735965 18.969697,27.9069767 C18.969697,17.1181584 27.7069279,8.37209302 38.4848485,8.37209302 Z M38.4848485,8.37209302 C40.0478624,8.37209302 41.5432444,8.55602976 43,8.90345889 C51.5884498,10.9517624 58,18.6827527 58,27.9069767 C58,24.2735965 49.0891449,21.9912677 44.6457475,21.7263354 C44.2858734,17.8296126 42.3627861,8.37209302 38.4848485,8.37209302 Z M38.4848485,47.4418605 C27.7069279,47.4418605 18.969697,38.6957951 18.969697,27.9069767 C18.969697,31.540357 27.8805521,33.8226858 32.3239495,34.0876181 C32.6838236,37.9843409 34.6069109,47.4418605 38.4848485,47.4418605 Z M38.4848485,47.4418605 C42.3627861,47.4418605 44.2858734,37.9843409 44.6457475,34.0876181 C49.0891449,33.8226858 58,31.540357 58,27.9069767 C58,38.6957951 49.2627691,47.4418605 38.4848485,47.4418605 Z M43.3802566,21.7068344 C42.0792621,21.4288131 34.9586855,21.4261503 33.5935159,21.6674857 C34.3208096,14.6707421 36.2362897,9.6744186 38.4848485,9.6744186 C40.7376202,9.6744186 42.656064,14.6894821 43.3802566,21.7068344 Z M32.2970459,22.9630883 C32.0190246,24.2640828 32.0163618,31.3846594 32.2576972,32.749829 C25.2609536,32.0225353 20.2646301,30.1070552 20.2646301,27.8584964 C20.2646301,25.6057247 25.2796935,23.687281 32.2970459,22.9630883 Z M44.723619,22.9630883 C51.7409713,23.687281 56.7560348,25.6057247 56.7560348,27.8584964 C56.7560348,30.1070552 51.7597112,32.0225353 44.7629677,32.749829 C45.0043031,31.3846594 45.0016403,24.2640828 44.723619,22.9630883 Z M43.3797934,34.1581385 C42.6556008,41.1754909 40.737157,46.1905543 38.4843853,46.1905543 C36.2358265,46.1905543 34.3203464,41.1942308 33.5930527,34.1974872 C34.9582223,34.4388226 42.0787989,34.4361598 43.3797934,34.1581385 Z M43.4891925,32.9263777 C42.4230562,33.1612691 34.6207278,33.129633 33.4809225,32.9315002 C33.3505988,31.3353915 33.2808081,29.6497388 33.2808081,27.9069767 C33.2808081,26.1517255 33.3487915,24.5007385 33.4809225,22.8944858 C35.8979554,22.6592819 41.1081896,22.6057867 43.5299948,22.8944858 C43.6630641,24.5059718 43.6888889,26.1452717 43.6888889,27.9069767 C43.6888889,29.6478745 43.6192474,31.331785 43.4891925,32.9263777 Z M46.8484848,60 C45.3881836,60 31.7247869,60 30.1212121,60 C30.1212121,57.5499092 31.1726102,55.3456339 32.8484053,53.814607 C25.596184,52.4700218 12,44.6913608 12,27.9069767 C12,17.0152545 19.8516706,2.17169264 37.0909091,1.42470867 C37.0885501,1.20959584 37.0905178,0.734692951 37.0968122,4.70457007e-14 L39.8787879,0 L39.8781545,5.58139535 L37.0873706,5.58139535 C37.0873706,4.90677235 37.0905178,4.45354508 37.0968122,4.22171355 C21.0532642,5.05463795 14.7878788,20.2677101 14.7878788,27.9069767 C14.7878788,44.2573583 29.6978575,51.5854095 37.0873706,51.5854095 C37.0873706,51.42458 37.0873706,50.5137084 37.0873706,48.8527946 L39.8787879,48.8527946 C39.8787879,50.5593943 39.8787879,51.5237206 39.8787879,51.7457735 C43.8282319,52.4152207 46.8484848,55.8560071 46.8484848,60 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-16-lg span-16-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('h2', [_vm._v("Fonts")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Title")]), _vm._v(" "), _c('h1', [_vm._v("Header 1")]), _vm._v(" "), _c('h2', [_vm._v("Header 2")]), _vm._v(" "), _c('p', {
    staticClass: "subheader"
  }, [_vm._v("Subheader")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v("Paragraph Large")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v(_vm._s(_vm.lorem_ipsum))]), _vm._v(" "), _c('p', [_vm._v("Paragraph")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lorem_ipsum))])])])
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Understanding",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M33.4026903,21.6563444 L35.8526991,21.6563444 L36.1169158,20.1467116 C38.7350625,19.6022539 40.8487956,18.3153539 40.8487956,15.1723481 L40.8487956,15.122852 C40.8487956,11.8313577 38.4948655,10 35.0360295,10 C32.4178829,10 30.5443467,11.0889154 29.1512044,12.6727923 L31.3610163,15.1723481 C32.4659222,14.0339366 33.6188676,13.4647308 34.9639705,13.4647308 C36.3571127,13.4647308 37.1737823,14.1081808 37.1737823,15.2218443 L37.1737823,15.2713404 C37.1737823,16.5829885 35.9968173,17.3996751 32.9703358,17.5234155 L32.8502374,17.6471558 L33.4026903,21.6563444 Z M32.6100404,27.5463867 L36.5012309,27.5463867 L36.5012309,23.5866944 L32.6100404,23.5866944 L32.6100404,27.5463867 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Relatioinships",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2,18.7330998 L13.3883237,5 L25.9370422,15.9012693 L29.454036,15.0045897 C24.6262912,19.6085177 21.7938413,22.3333252 20.9566861,23.1790123 C17.2686945,26.9045906 24.1066811,33.2507182 27.2720705,30.231007 C28.352418,29.2003795 36.0217235,22.1122203 36.7510212,22.1122203 C37.9688059,22.1122203 51.4283087,34.5528346 53.6154755,36.4927705 C55.8026424,38.4327063 53.1654739,41.3561596 51.0857162,39.6873608 C49.3083263,38.2611821 44.7964163,34.1854063 44.339894,33.8471344 C43.8833716,33.5088626 43.0253082,34.3633388 43.4302096,34.781188 C43.8351111,35.1990372 49.9954334,40.9667621 50.434489,41.4247361 C52.2772477,43.346897 49.1148353,46.5738472 47.2287904,44.9643896 C46.0467087,43.9556593 40.6867425,39.3933198 40.2238952,38.996181 C39.7610479,38.5990423 38.5950664,39.6863887 39.2384457,40.1722216 C39.881825,40.6580545 45.3089253,45.7973891 45.8477432,46.2958058 C47.7880976,48.0906704 44.7039194,51.0859053 43.1472266,49.8372801 C41.735901,48.7052541 36.7797846,44.5943606 36.2286216,44.1164993 C35.6774586,43.638638 34.778197,44.6350052 35.1872658,44.9643896 C35.5963345,45.2937739 41.2979831,50.2969365 41.7623308,50.7179449 C43.6848061,52.4609885 41.1104954,55.8725899 38.8874359,54.1093102 C37.8529402,53.2887719 16.6708215,35.7938159 15.846097,34.781188 C15.0213724,33.7685601 15.2890214,30.1734985 14.7428346,29.6310876 C14.3787101,29.2694803 10.1310986,25.6368177 2,18.7330998 Z M22.714088,23.9269603 C23.9905885,22.6598263 32.724252,13.487382 34.6668917,13.1645607 C36.6095314,12.8417394 44.3007383,16.2001292 45.1344697,15.5933181 C45.6902906,15.1887774 49.8073232,11.8481317 57.4855677,5.57138099 L68,18.0259194 C59.5780932,25.3680932 55.2651527,29.408262 55.0611784,30.1464258 C54.8572042,30.8845895 54.4565294,32.237793 53.859154,34.2060362 C45.0834473,26.2520076 39.8576953,21.7455718 38.181898,20.6867289 C37.434109,20.2142427 35.8436847,20.2200668 35.1872658,20.6867289 C34.6623568,21.0598978 28.0974709,27.2535265 26.9645859,28.2337814 C24.2749219,30.5610755 20.1200032,26.5020105 22.714088,23.9269603 Z M29.1014402,50.516966 C29.3674313,50.1651122 29.8263285,49.6326371 30.478132,48.9195407 L34.8364686,52.5070821 C34.1752117,53.2593085 33.5437518,53.9335734 32.9420891,54.5298768 C31.2977483,56.1595706 27.0409217,53.2426265 29.1014402,50.516966 Z M24.0847181,46.1220286 C24.3549787,45.7743725 24.7458995,45.3257589 25.2574804,44.7761878 L29.2856583,48.1732633 C28.9880761,48.6004121 28.5580363,49.1285574 27.9955391,49.7576992 C26.1663578,51.8036014 22.1535049,48.6062896 24.0847181,46.1220286 Z M19.7523557,41.1950717 C19.9007741,41.0073287 20.0700474,40.8199164 20.2601755,40.6328349 L24.2883534,44.0299104 C23.9683285,44.4215113 23.7225649,44.6994393 23.5510626,44.8636945 C22.0105013,46.339156 18.3048868,43.026059 19.7523557,41.1950717 Z M15.361305,36.7805818 C15.4258816,36.6783063 15.5134175,36.5812731 15.6239129,36.489482 L19.3969142,39.7007404 C19.2832152,39.8461442 19.1819325,39.957124 19.093066,40.0336798 C18.2058317,40.7980047 14.6818314,37.8567211 15.361305,36.7805818 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Audio Demo")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.speechText),
      expression: "speechText"
    }],
    attrs: {
      "placeholder": _vm.placeholder,
      "cols": "100",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.speechText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.speechText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    ref: "voiceSelect",
    on: {
      "change": _vm.doThis
    }
  }, _vm._l((_vm.voiceOptions), function(option, index) {
    return _c('option', {
      key: index,
      attrs: {
        "index": index
      },
      domProps: {
        "value": option.title
      }
    }, [_vm._v(_vm._s(option.title))])
  })), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.readText
    }
  }, [_vm._v("Read")])])
},staticRenderFns: []}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Conflict-Resolution",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.0199332,28.199233 C16.2633815,27.977708 15.5295126,27.719377 14.8214286,27.4265937 C13.8616507,28.301409 9.4330052,30 7.67857143,30 C8.49458967,29.1428571 10.3571429,27.4285714 10.3571429,24.8571429 C7.01928342,22.2262444 5,18.5579678 5,14.5714286 C5,6.52385079 13.3946609,0 23.75,0 C34.1053391,0 42.5,6.52386153 42.5,14.5714286 C42.5,15.8068382 42.3439929,16.9556905 42.0557038,18.0209557 C28.7954102,17.5239258 19.8779297,23.2629395 17.0199332,28.199233 Z M40,58.8571429 C29.4188291,58.8571429 15,53.1428571 15,39.4285714 C15,28.698482 26.1928813,20 40,20 C53.8071187,20 65,28.6984677 65,39.4285714 C65,44.7439571 62.3076221,49.6349926 57.8571429,53.1428571 C57.8571429,56.5714286 60.3405471,58.8571429 61.4285714,60 C59.0893264,60 53.1844657,57.7352121 51.9047619,56.5687916 C48.3502543,58.0385331 44.3084254,58.8571429 40,58.8571429 Z M40,49 C46.6666667,45.3509081 50,41.622758 50,37.8155496 C50,32.104737 45.5228475,30.0075371 40,34.2280844 C34.4771525,30.0075371 30,32.104737 30,37.8155496 C30,41.622758 33.3333333,45.3509081 40,49 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "viewBox": "0 0 628 598",
      "preserveAspectRatio": "none"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#1E7BBB"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "opacity": "0.5",
      "x": "0",
      "y": "0",
      "width": "1.03857567",
      "height": "596.16559"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Top",
      "x": "0",
      "y": "0",
      "width": "49.851632",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "128.927445",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "61.2933754",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "26.5076236",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "95.1104101",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "163.801262",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "232.492114",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "301.182965",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "368.817035",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "197.618297",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "266.309148",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "335",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "403.690852",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "437.507886",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "472.381703",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "506.198738",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "541.072555",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-2",
      "x": "1.03857567",
      "y": "574.88959",
      "width": "18.694362",
      "height": "1.05678233"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Bottom",
      "x": "0",
      "y": "594.968454",
      "width": "49.851632",
      "height": "1.05678233"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row max-height-vertical box-overflow"
  }, [_c('div', {
    staticClass: "row scroll-outer"
  }, [_c('div', {
    staticClass: "span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('p', {
    staticClass: "large",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _vm._l((_vm.content.paragraphs), function(paragraph, index) {
    return _c('div', {
      key: index,
      staticClass: "relative span-6-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs bg-white share-flip-outer no-ratio-md",
      class: _vm.lg_offset(index),
      style: (_vm.ratio_styles),
      attrs: {
        "container-card": "share-card"
      }
    }, [_c('div', {
      staticClass: "scroll-outer"
    }, [_c('div', {
      staticClass: "share-flip-inner"
    }, [_c('p', [_vm._v(_vm._s(paragraph))]), _vm._v(" "), _c('div', {
      staticClass: "share-button-container"
    }, [_c('nav-button', {
      attrs: {
        "type": "share"
      }
    }, [_vm._v("share")])], 1)])])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-outer-container scroll-outer",
    class: _vm.containerClass
  }, [_c('div', {
    staticClass: "gutter-horizontal-IEonly login-inner-container content-translate",
    class: _vm.innerClass
  }, [(_vm.logInModal) ? _c('div', {
    staticClass: "pad-60"
  }, [_c('p', {
    staticClass: "content-translate text-center color-red",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('h1', {
    staticClass: "upcase text-center"
  }, [_vm._v("sign in")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "text",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keydown": _vm.checkForEnter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "keydown": _vm.checkForEnter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row  margin-top-24"
  }, [_c('div', {
    staticClass: "span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs "
  }, [_c('p', {
    staticClass: "a",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Don't have an account? Sign Up")])]), _vm._v(" "), _c('div', {
    staticClass: "span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs "
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "float-right call-to-action",
      "clickevent": _vm.logIn
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "span-14-xs offset-1-xs show-xs"
  }, [_c('p', {
    staticClass: "a text-center",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Don't have an account? Sign Up")])])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.signUpModal) ? _c('div', {
    staticClass: "pad-60"
  }, [_c('p', {
    staticClass: "content-translate text-center color-red",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _c('h1', {
    staticClass: "upcase text-center"
  }, [_vm._v("Sign Up")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.firstName),
      expression: "newUser.firstName"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "text",
      "placeholder": "first name"
    },
    domProps: {
      "value": (_vm.newUser.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.lastName),
      expression: "newUser.lastName"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "text",
      "placeholder": "last name"
    },
    domProps: {
      "value": (_vm.newUser.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.lastName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "email",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-text-area text-area-small p ",
    attrs: {
      "type": "password",
      "placeholder": "confirm password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-24"
  }, [_c('div', {
    staticClass: "span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs "
  }, [_c('p', {
    staticClass: "a",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Already have an account? Sign In")])]), _vm._v(" "), _c('div', {
    staticClass: "span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs "
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "float-right call-to-action",
      "clickevent": _vm.register
    }
  }, [_vm._v("Submit")])], 1), _vm._v(" "), _c('div', {
    staticClass: "span-14-xs offset-1-xs show-xs"
  }, [_c('p', {
    staticClass: "a text-center",
    on: {
      "click": _vm.toggleModal
    }
  }, [_vm._v("Already have an account? Sign In")])])])]) : _vm._e(), _vm._v(" "), (_vm.continueCondition) ? _c('div', {
    staticClass: "pad-60"
  }, [_c('h1', {
    staticClass: "upcase text-center"
  }, [_vm._v(_vm._s(_vm.status) + "!")]), _vm._v(" "), (_vm.showContinueControls) ? _c('div', {
    staticClass: "row margin-top-24"
  }, [_c('div', {
    staticClass: "span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs "
  }, [_c('p', {
    staticClass: "a",
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Not you? Switch user")])]), _vm._v(" "), _c('div', {
    staticClass: "span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs"
  }, [_c('nav-button', {
    attrs: {
      "type": "next",
      "customclass": "float-right call-to-action",
      "clickevent": _vm.loginSuccess
    }
  }, [_vm._v("Resume")])], 1), _vm._v(" "), _c('div', {
    staticClass: "span-14-xs offset-1-xs show-xs"
  }, [_c('p', {
    staticClass: "a text-center",
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Not you? Switch user")])])]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-small"
  }, [_c('p', {
    staticClass: "text-center "
  }, [_c('em', [_c('strong', [_vm._v("Please make note of your login and password information.")]), _vm._v(" If these are misplaced, you will need to create a new login by notifying us at "), _c('a', {
    attrs: {
      "href": "mailto:kcoleman@futureswithoutviolence.org"
    }
  }, [_vm._v("kcoleman@futureswithoutviolence.org")]), _vm._v(" and restarting the module from the beginning.")])])])
}]}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Problem-Solving",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60,55 C55.127024,55 13.3021113,55 10,55 C10,43.8366699 14.1764427,34.2923521 24.1662077,30.4365191 C23.1158447,29.284668 20.0156657,25.7830811 20.0156657,20.0223796 C20.0156657,13.3143916 25.6017125,5 35,5 C43.7435452,5 49.9338786,12.3539225 49.9338786,20.0223796 C49.9338786,26.9734701 45.8765671,30 45.8765671,30.4549123 C55.8335853,34.3226378 60,43.8543791 60,55 Z M34.2727273,11 L31.5090909,13.7636364 L32.9348155,14.3746612 C33.1627192,14.4723342 33.3699071,14.6125704 33.5452783,14.787856 C34.3070914,15.5492971 34.3073929,16.7841387 33.5459517,17.5459517 C33.3705643,17.7214248 33.1632949,17.8618077 32.9352704,17.9595643 C31.945701,18.3838035 30.7995828,17.9255128 30.3753436,16.9359435 L29.7636364,15.5090909 L27,18.2727273 L30.4909091,21.7636364 L29.0651845,22.3746612 C28.8371935,22.4723716 28.629941,22.6126884 28.4545455,22.7880839 C27.6931186,23.5495108 27.6931186,24.7840277 28.4545455,25.5454545 C28.629941,25.7208501 28.8371935,25.8611669 29.0651845,25.9588773 C30.0549384,26.3830575 31.2011585,25.9245695 31.6253388,24.9348155 L32.2363636,23.5090909 L35.7272727,27 L38.4909091,24.2363636 L37.0651845,23.6253388 C36.8371935,23.5276284 36.629941,23.3873116 36.4545455,23.2119161 C35.6931186,22.4504892 35.6931186,21.2159723 36.4545455,20.4545455 C36.629941,20.2791499 36.8371935,20.1388331 37.0651845,20.0411227 C38.0549384,19.6169425 39.2011585,20.0754305 39.6253388,21.0651845 L40.2363636,22.4909091 L43,19.7272727 L39.5090909,16.2363636 L40.9348155,15.6253388 C41.1628065,15.5276284 41.370059,15.3873116 41.5454545,15.2119161 C42.3068814,14.4504892 42.3068814,13.2159723 41.5454545,12.4545455 C41.370059,12.2791499 41.1628065,12.1388331 40.9348155,12.0411227 C39.9450616,11.6169425 38.7988415,12.0754305 38.3746612,13.0651845 L37.7636364,14.4909091 L34.2727273,11 Z",
      "id": "Combined-Shape"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-button-container",
    class: _vm.button_disabled
  }, [_c('input', {
    ref: "radioCheckbox",
    staticClass: "radio-button-checkbox",
    class: _vm.group,
    attrs: {
      "type": "checkbox",
      "radio": ""
    },
    on: {
      "click": _vm.check
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-button",
    class: [_vm.type, _vm.is_correct]
  }, [_c('div', {
    staticClass: "radio-button-indicator",
    class: [_vm.type, _vm.is_correct]
  })])])
},staticRenderFns: []}

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Comfort",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M35,55 C15,44.2673769 5,33.3022295 5,22.1045577 C5,5.63129001 17.9194693,-0.618839965 34.0470003,10.8571114 C34.2579709,11.0072328 33.7452803,13.3857136 32.5089286,17.9925537 L35,19.883016 L34.0470003,25.5086263 L37.4320592,19.605306 L34.4536133,17.3307292 C35.3981336,13.0542529 35.8786238,10.9101395 35.8950839,10.8983892 C52.0495894,-0.633785039 65,5.61157559 65,22.1045577 C65,33.3022295 55,44.2673769 35,55 Z M18.2973033,32.1145052 C17.5578827,32.931545 19.1344412,38.7749259 20.1608004,39.0691712 C20.84504,39.2653347 24.2421377,38.665668 30.3520937,37.270171 L28.0227223,28.5768385 C22.0320567,30.3905898 18.7902504,31.5698121 18.2973033,32.1145052 Z M49.0017382,24.0633227 C48.3107738,23.8138118 44.8948174,24.2945562 38.753869,25.505556 L40.7784285,34.2748866 C46.8283456,32.6385868 50.1093313,31.5732203 50.6213857,31.0787872 C51.3894674,30.3371375 50.0381847,24.437589 49.0017382,24.0633227 Z M28.9886481,28.3180195 L31.3180195,37.0113519 L40.0113519,34.6819805 L37.6819805,25.9886481 L28.9886481,28.3180195 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow-container"
  }, [_c('div', {
    staticClass: "bracket-left"
  }, [_c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('polygon', {
    attrs: {
      "points": "0 24 6 24 6 22 2.08571429 22 2.08571429 2 6 2 6 0 0 0"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "bracket-right"
  }, [_c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('polygon', {
    attrs: {
      "points": "30 24 36 24 36 0 30 0 30 2 34 2 34 22 30 22"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }, [(_vm.type === 'next') ? _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('polygon', {
    attrs: {
      "points": "13 18 23 13 23 11 13 6 13 8 21 12.0218182 13 16"
    }
  })])])]) : (_vm.type === 'share') ? _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group share-icon"
  }, [_c('path', {
    attrs: {
      "d": "M16.9990234,18 L19,18 L19,13 L24,13 L24,11 L19,11 L19,6 L16.9990234,6 L16.9990234,11 L12,11 L12,13 L16.9990234,13 L16.9990234,18 Z"
    }
  })])])]) : _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('path', {
    attrs: {
      "d": "M23,18 L13,13 L13,11 L23,6 L23,8 L15,12.0218182 L23,16 L23,18 Z"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-white max-height-vertical max-height-full box-overflow"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "row scroll-outer"
  }, [_c('div', [_c('div', {
    staticClass: "row padding-top-96"
  }, [_c('div', {
    staticClass: "span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('h1', {
    staticClass: "upcase"
  }, [_vm._v("Pre-Survey")]), _vm._v(" "), _c('p', [_vm._v("To help us better serve you and your students, please fill out this quick survey before beginning this module.")]), _vm._v(" "), (_vm.showErrorMessage) ? _c('p', {
    staticClass: "color-red subheader"
  }, [_vm._v("Please fill out all required fields.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "border-error-container",
    class: [_vm.presurvey_0_group, _vm.presurvey_1_group]
  }, [_c('survey-caption', {
    attrs: {
      "ind": "1"
    }
  }, [_c('p', {
    staticClass: "p subheader upcase border-error-container"
  }, [_vm._v("School")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    ref: "presurvey-0-group",
    staticClass: "form-text-area text-area-small p transform-up-24-lg",
    attrs: {
      "type": "text",
      "placeholder": "School Name"
    },
    on: {
      "keyup": function($event) {
        _vm.textToStore('presurvey-0-group', 'School Name')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('input', {
    ref: "presurvey-1-group",
    staticClass: "form-text-area text-area-small p transform-up-24-lg",
    attrs: {
      "type": "text",
      "placeholder": "School District"
    },
    on: {
      "keyup": function($event) {
        _vm.textToStore('presurvey-1-group', 'School District')
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "border-error-container",
    class: [_vm.presurvey_2_group]
  }, [_c('survey-caption', {
    attrs: {
      "ind": "2"
    }
  }, [_vm._v("What position do you hold?")]), _vm._v(" "), _c('div', {
    staticClass: "row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('radio-span', {
    attrs: {
      "group": "presurvey-2-group",
      "survey": "true",
      "title": "Teacher",
      "groupQuestion": "What position do you hold?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-2-group",
      "survey": "true",
      "title": "School Administrator",
      "groupQuestion": "What position do you hold?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-2-group",
      "survey": "true",
      "title": "School Counselor",
      "groupQuestion": "What position do you hold?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-2-group",
      "survey": "true",
      "title": "Social Worker/School Nurse/Wellness Center Staff",
      "groupQuestion": "What position do you hold?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-2-group",
      "survey": "true",
      "title": "School Climate/Attendance Coordinator",
      "groupQuestion": "What position do you hold?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-2-group",
      "survey": "true",
      "title": "District Administrator",
      "groupQuestion": "What position do you hold?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-2-group",
      "survey": "true",
      "title": "Other",
      "groupQuestion": "What position do you hold?"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-5-lg offset-3-lg span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherText),
      expression: "otherText"
    }],
    ref: "presurvey-2-group",
    staticClass: "form-text-area p",
    attrs: {
      "placeholder": "If other please specify"
    },
    domProps: {
      "value": (_vm.otherText)
    },
    on: {
      "keyup": function($event) {
        _vm.textToStore('presurvey-2-group', 'What position do you hold?', true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherText = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "border-error-container",
    class: [_vm.presurvey_3_group]
  }, [_c('survey-caption', {
    attrs: {
      "ind": "3"
    }
  }, [_vm._v("Have you received any training on children’s exposure to violence and trauma?")]), _vm._v(" "), _c('div', {
    staticClass: "row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('radio-span', {
    attrs: {
      "group": "presurvey-3-group",
      "full": "true",
      "title": "Yes",
      "groupQuestion": "Have you received any training on children’s exposure to violence and trauma?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-3-group",
      "full": "true",
      "title": "No",
      "groupQuestion": "Have you received any training on children’s exposure to violence and trauma?"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border-error-container",
    class: [_vm.presurvey_4_group]
  }, [_c('survey-caption', {
    attrs: {
      "ind": "4"
    }
  }, [_vm._v("What is your level of knowledge on children’s exposure to violence and trauma?")]), _vm._v(" "), _c('div', {
    staticClass: "row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs"
  }, [_c('radio-span', {
    attrs: {
      "group": "presurvey-4-group",
      "full": "true",
      "title": "Low",
      "groupQuestion": "What is your level of knowledge on children’s exposure to violence and trauma?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-4-group",
      "full": "true",
      "title": "Medium",
      "groupQuestion": "What is your level of knowledge on children’s exposure to violence and trauma?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-4-group",
      "full": "true",
      "title": "High",
      "groupQuestion": "What is your level of knowledge on children’s exposure to violence and trauma?"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border-error-container",
    class: [_vm.presurvey_5_group]
  }, [_c('survey-caption', {
    attrs: {
      "ind": "5"
    }
  }, [_vm._v("Do you think students at your school are affected by violence and trauma?")]), _vm._v(" "), _c('div', {
    staticClass: "row span-10-lg offset-3-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs padding-bottom-96"
  }, [_c('radio-span', {
    attrs: {
      "group": "presurvey-5-group",
      "full": "true",
      "title": "Yes",
      "groupQuestion": "Do you think students at your school are affected by violence and trauma?"
    }
  }), _vm._v(" "), _c('radio-span', {
    attrs: {
      "group": "presurvey-5-group",
      "full": "true",
      "title": "No",
      "groupQuestion": "Do you think students at your school are affected by violence and trauma?"
    }
  })], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-1-lg offset-2-lg span-1-md hide-sm"
  }, [_c('div', {
    staticClass: "p subheader survey-number transition-1"
  }, [_vm._v(_vm._s(_vm.ind) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "span-10-lg span-14-md span-14-sm offset-1-sm span-14-xs offset-1-xs "
  }, [_c('p', {
    staticClass: "large border-error-container"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Networks",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M47.25,25.4565833 C44.8622418,25.4565833 24.3680346,25.4565833 22.75,25.4565833 C22.75,19.7729785 24.7964569,14.913664 29.6914418,12.9505373 C29.1767639,12.3640935 27.6576762,10.5813247 27.6576762,7.64836913 C27.6576762,4.23312005 30.3948391,6.72043399e-15 35,0 C39.2843371,-6.25224733e-15 42.3176005,3.74411483 42.3176005,7.64836913 C42.3176005,11.1873894 40.3295179,12.7282916 40.3295179,12.9599019 C45.2084568,14.9290834 47.25,19.7819948 47.25,25.4565833 Z M24.5,60 C22.1122418,60 1.61803455,60 0,60 C0,54.3163952 2.0464569,49.4570807 6.94144178,47.493954 C6.42676392,46.9075102 4.90767619,45.1247414 4.90767619,42.1917858 C4.90767619,38.7765368 7.6448391,34.5434167 12.25,34.5434167 C16.5343371,34.5434167 19.5676005,38.2875315 19.5676005,42.1917858 C19.5676005,45.7308061 17.5795179,47.2717084 17.5795179,47.5033186 C22.4584568,49.4725001 24.5,54.3254115 24.5,60 Z M70,60 C67.6122418,60 47.1180346,60 45.5,60 C45.5,54.3163952 47.5464569,49.4570807 52.4414418,47.493954 C51.9267639,46.9075102 50.4076762,45.1247414 50.4076762,42.1917858 C50.4076762,38.7765368 53.1448391,34.5434167 57.75,34.5434167 C62.0343371,34.5434167 65.0676005,38.2875315 65.0676005,42.1917858 C65.0676005,45.7308061 63.0795179,47.2717084 63.0795179,47.5033186 C67.9584568,49.4725001 70,54.3254115 70,60 Z M10.5,7.27229825 L15.75,7.27756916 L15.75,9.09564372 L12.2739258,9.09037282 L12.2739258,12.7335128 L10.5,12.7335128 L10.5,7.27229825 Z M59.5,7.27229825 L59.5,12.7335128 L57.7260742,12.7335128 L57.7260742,9.09037282 L54.25,9.09037282 L54.25,7.27229825 L59.5,7.27229825 Z M19.25,7.27229825 L24.5,7.27229825 L24.5,9.09037282 L19.25,9.09037282 L19.25,7.27229825 Z M10.5,16.3626711 L12.25,16.3626711 L12.25,21.8168948 L10.5,21.8168948 L10.5,16.3626711 Z M10.5,25.4530439 L12.25,25.4530439 L12.25,30.9072676 L10.5,30.9072676 L10.5,25.4530439 Z M59.5,25.4530439 L59.5,30.9072676 L57.75,30.9072676 L57.75,25.4530439 L59.5,25.4530439 Z M57.75,16.3626711 L59.5,16.3626711 L59.5,21.8168948 L57.75,21.8168948 L57.75,16.3626711 Z M36.75,58.178386 L42,58.178386 L42,59.9964606 L36.75,59.9964606 L36.75,58.178386 Z M28,58.178386 L33.25,58.178386 L33.25,59.9964606 L28,59.9964606 L28,58.178386 Z M45.5,7.27229825 L50.75,7.27229825 L50.75,9.09037282 L45.5,9.09037282 L45.5,7.27229825 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative span-6-lg offset-1-lg span-6-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs debug ratio-flip-card testing-outer"
  }, [_c('div', {
    staticClass: "testing"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ })
]),[262]);


// WEBPACK FOOTER //
// assets/js/app.b43020d207ad243fbf0e.js